function PlanG({ ...props }) {
	return (
		<g {...props} id="unit-g">
			<g id="furniture">
				<polyline
					points="384.02 831.68 381.22 831.68 381.22 826.16 384.02 826.16 384.02 831.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="310.68 900.73 203.01 900.73 203.01 840.67 310.68 840.67 310.68 900.73"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="514.71"
					y1="526.83"
					x2="635.63"
					y2="526.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="499.01"
					x2="514.71"
					y2="505.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="508.62"
					x2="514.71"
					y2="514.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="518.23"
					x2="514.71"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="524.33"
					x2="520.52"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524.12"
					y1="524.33"
					x2="530.13"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.73"
					y1="524.33"
					x2="539.74"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.34"
					y1="524.33"
					x2="549.35"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.95"
					y1="524.33"
					x2="558.96"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.56"
					y1="524.33"
					x2="568.56"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.17"
					y1="524.33"
					x2="578.17"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.78"
					y1="524.33"
					x2="587.78"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.39"
					y1="524.33"
					x2="597.39"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601"
					y1="524.33"
					x2="607"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.61"
					y1="524.33"
					x2="616.61"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.22"
					y1="524.33"
					x2="626.22"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.83"
					y1="524.33"
					x2="635.63"
					y2="524.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.63"
					y1="524.33"
					x2="635.63"
					y2="518.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.63"
					y1="514.62"
					x2="635.63"
					y2="508.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.63"
					y1="505.01"
					x2="635.63"
					y2="499.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.14"
					y1="518.11"
					x2="648.14"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.45"
					y1="518.11"
					x2="648.14"
					y2="518.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.45"
					y1="406.87"
					x2="759.45"
					y2="518.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.14"
					y1="555.65"
					x2="653.49"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.1"
					y1="555.65"
					x2="663.1"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.71"
					y1="555.65"
					x2="672.71"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.32"
					y1="555.65"
					x2="682.32"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.93"
					y1="555.65"
					x2="691.93"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.54"
					y1="555.65"
					x2="701.54"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.15"
					y1="555.65"
					x2="711.15"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.76"
					y1="555.65"
					x2="720.76"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.36"
					y1="555.65"
					x2="730.37"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.97"
					y1="555.65"
					x2="739.98"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.58"
					y1="555.65"
					x2="749.59"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.19"
					y1="555.65"
					x2="759.2"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.67"
					y1="406.87"
					x2="771.66"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.06"
					y1="406.87"
					x2="761.95"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="406.87"
					x2="761.95"
					y2="409.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="412.69"
					x2="761.95"
					y2="418.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="422.3"
					x2="761.95"
					y2="428.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="431.91"
					x2="761.95"
					y2="437.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="441.52"
					x2="761.95"
					y2="447.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="451.13"
					x2="761.95"
					y2="457.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="460.74"
					x2="761.95"
					y2="466.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="470.35"
					x2="761.95"
					y2="476.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="479.96"
					x2="761.95"
					y2="485.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="489.57"
					x2="761.95"
					y2="495.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="499.18"
					x2="761.95"
					y2="505.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="508.79"
					x2="761.95"
					y2="514.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="518.39"
					x2="761.95"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.95"
					y1="520.62"
					x2="759.7"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.1"
					y1="520.62"
					x2="750.09"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.49"
					y1="520.62"
					x2="740.48"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.88"
					y1="520.62"
					x2="730.87"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.27"
					y1="520.62"
					x2="721.26"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.66"
					y1="520.62"
					x2="711.65"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.05"
					y1="520.62"
					x2="702.04"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.44"
					y1="520.62"
					x2="692.43"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.83"
					y1="520.62"
					x2="682.82"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.22"
					y1="520.62"
					x2="673.21"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.61"
					y1="520.62"
					x2="663.6"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660"
					y1="520.62"
					x2="653.99"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.39"
					y1="520.62"
					x2="648.14"
					y2="520.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.14"
					y1="520.62"
					x2="648.14"
					y2="526.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.14"
					y1="530.33"
					x2="648.14"
					y2="536.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.14"
					y1="539.94"
					x2="648.14"
					y2="545.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.14"
					y1="549.55"
					x2="648.14"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="687.98 594.52 749.81 594.52 749.81 656.35 687.98 656.35 687.98 594.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="213.19 736.06 213.19 646.29 446.05 646.29 446.05 736.06 213.19 736.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="213.19"
					y1="736.06"
					x2="446.05"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.05"
					y1="736.06"
					x2="446.05"
					y2="646.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.05"
					y1="646.29"
					x2="213.19"
					y2="646.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.19"
					y1="646.29"
					x2="213.19"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="428.85 55 428.85 57.51 296.57 57.51 296.57 55 428.85 55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="428.85"
					y1="55"
					x2="428.85"
					y2="57.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.85"
					y1="57.51"
					x2="296.57"
					y2="57.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="296.57"
					y1="57.51"
					x2="296.57"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="296.57"
					y1="55"
					x2="428.85"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="478.88 54.02 437.76 54.02 437.76 59.44 478.88 59.44 478.88 54.02"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="435.79 53.53 480.86 53.53 480.86 54.02 435.79 54.02 435.79 53.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="435.79"
					y1="53.53"
					x2="480.86"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.86"
					y1="53.53"
					x2="480.86"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.86"
					y1="54.02"
					x2="435.79"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.79"
					y1="54.02"
					x2="435.79"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.88"
					y1="59.44"
					x2="437.76"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.76"
					y1="54.02"
					x2="478.88"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="483.32 59.44 478.88 59.44 478.88 54.02 483.32 54.02 483.32 59.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="483.32"
					y1="59.44"
					x2="478.88"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.88"
					y1="59.44"
					x2="478.88"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.88"
					y1="54.02"
					x2="483.32"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.32"
					y1="54.02"
					x2="483.32"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="433.32 54.02 437.76 54.02 437.76 59.44 433.32 59.44 433.32 54.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="433.32"
					y1="54.02"
					x2="437.76"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.76"
					y1="54.02"
					x2="437.76"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.76"
					y1="59.44"
					x2="433.32"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.32"
					y1="59.44"
					x2="433.32"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.88"
					y1="55"
					x2="437.76"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="485.29 58.95 483.32 58.95 483.32 54.02 480.86 54.02 480.86 53.53 485.29 53.53 485.29 58.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="485.29"
					y1="58.95"
					x2="483.32"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.32"
					y1="58.95"
					x2="483.32"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.32"
					y1="54.02"
					x2="480.86"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.86"
					y1="54.02"
					x2="480.86"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.86"
					y1="53.53"
					x2="485.29"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.29"
					y1="53.53"
					x2="485.29"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="431.36 53.53 435.79 53.53 435.79 54.02 433.32 54.02 433.32 58.95 431.36 58.95 431.36 53.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="431.36"
					y1="53.53"
					x2="435.79"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.79"
					y1="53.53"
					x2="435.79"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.79"
					y1="54.02"
					x2="433.32"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.32"
					y1="54.02"
					x2="433.32"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.32"
					y1="58.95"
					x2="431.36"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.36"
					y1="58.95"
					x2="431.36"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="426.35 55 431.36 55 431.36 70.02 426.35 70.02 426.35 55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="431.36"
					y1="55"
					x2="426.35"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.36"
					y1="70.02"
					x2="431.36"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.35"
					y1="70.02"
					x2="431.36"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.35"
					y1="55"
					x2="426.35"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="490.29 55 490.29 70.02 485.29 70.02 485.29 55 490.29 55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="490.29"
					y1="70.02"
					x2="490.29"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.29"
					y1="70.02"
					x2="490.29"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.29"
					y1="55"
					x2="485.29"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.29"
					y1="55"
					x2="485.29"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="294.07 55 299.07 55 299.07 70.02 294.07 70.02 294.07 55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="299.07"
					y1="55"
					x2="294.07"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.07"
					y1="70.02"
					x2="299.07"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.07"
					y1="70.02"
					x2="299.07"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.07"
					y1="55"
					x2="294.07"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="706.58 55 706.58 57.51 604.9 57.51 604.9 55 706.58 55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="706.58"
					y1="55"
					x2="706.58"
					y2="57.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.58"
					y1="57.51"
					x2="604.9"
					y2="57.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.9"
					y1="57.51"
					x2="604.9"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.9"
					y1="55"
					x2="706.58"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="757.53 54.02 715.49 54.02 715.49 59.44 757.53 59.44 757.53 54.02"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="713.52 53.53 759.5 53.53 759.5 54.02 713.52 54.02 713.52 53.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="713.52"
					y1="53.53"
					x2="759.5"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.5"
					y1="53.53"
					x2="759.5"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.5"
					y1="54.02"
					x2="713.52"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.52"
					y1="54.02"
					x2="713.52"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="59.44"
					x2="715.49"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.49"
					y1="54.02"
					x2="757.53"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="761.96 59.44 757.53 59.44 757.53 54.02 761.96 54.02 761.96 59.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="761.96"
					y1="59.44"
					x2="757.53"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="59.44"
					x2="757.53"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="54.02"
					x2="761.96"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.96"
					y1="54.02"
					x2="761.96"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="711.06 54.02 715.49 54.02 715.49 59.44 711.06 59.44 711.06 54.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="711.06"
					y1="54.02"
					x2="715.49"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.49"
					y1="54.02"
					x2="715.49"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.49"
					y1="59.44"
					x2="711.06"
					y2="59.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.06"
					y1="59.44"
					x2="711.06"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="55"
					x2="715.49"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="763.94 58.95 761.96 58.95 761.96 54.02 759.5 54.02 759.5 53.53 763.94 53.53 763.94 58.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="763.94"
					y1="58.95"
					x2="761.96"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.96"
					y1="58.95"
					x2="761.96"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.96"
					y1="54.02"
					x2="759.5"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.5"
					y1="54.02"
					x2="759.5"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.5"
					y1="53.53"
					x2="763.94"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.94"
					y1="53.53"
					x2="763.94"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="709.09 53.53 713.52 53.53 713.52 54.02 711.06 54.02 711.06 58.95 709.09 58.95 709.09 53.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="709.09"
					y1="53.53"
					x2="713.52"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.52"
					y1="53.53"
					x2="713.52"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.52"
					y1="54.02"
					x2="711.06"
					y2="54.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.06"
					y1="54.02"
					x2="711.06"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.06"
					y1="58.95"
					x2="709.09"
					y2="58.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.09"
					y1="58.95"
					x2="709.09"
					y2="53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="704.08 55 709.09 55 709.09 70.02 704.08 70.02 704.08 55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="709.09"
					y1="55"
					x2="704.08"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.09"
					y1="70.02"
					x2="709.09"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.08"
					y1="70.02"
					x2="709.09"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.08"
					y1="55"
					x2="704.08"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="768.94 55 768.94 70.02 763.94 70.02 763.94 55 768.94 55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="768.94"
					y1="70.02"
					x2="768.94"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.94"
					y1="70.02"
					x2="768.94"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.94"
					y1="55"
					x2="763.94"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.94"
					y1="55"
					x2="763.94"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="602.39 55 607.4 55 607.4 70.02 602.39 70.02 602.39 55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="607.4"
					y1="55"
					x2="602.39"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="607.4"
					y1="70.02"
					x2="607.4"
					y2="55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.39"
					y1="70.02"
					x2="607.4"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.39"
					y1="55"
					x2="602.39"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.94"
					y1="50"
					x2="768.94"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="599.24"
					y1="948.75"
					x2="603"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="599.24"
					y1="928.73"
					x2="603"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="599.24"
					y1="928.73"
					x2="599.24"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="504.15"
					y1="948.75"
					x2="500.39"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="504.15"
					y1="928.73"
					x2="500.39"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="504.15"
					y1="928.73"
					x2="504.15"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="605.79"
					y1="928.73"
					x2="599.24"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="505.4 950 505.4 948.75 500.39 948.75 500.39 950 505.4 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="597.99 948.75 597.99 950 603 950 603 948.75 597.99 948.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="505.4 928.73 505.4 927.48 500.39 927.48 500.39 928.73 505.4 928.73"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="597.99 927.48 597.99 928.73 603 928.73 603 927.48 597.99 927.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="505.4"
					y1="950"
					x2="500.39"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.39"
					y1="950"
					x2="500.39"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.39"
					y1="948.75"
					x2="505.4"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.4"
					y1="948.75"
					x2="505.4"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.99"
					y1="948.75"
					x2="603"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603"
					y1="948.75"
					x2="603"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603"
					y1="950"
					x2="597.99"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.99"
					y1="950"
					x2="597.99"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.4"
					y1="928.73"
					x2="500.39"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.39"
					y1="928.73"
					x2="500.39"
					y2="927.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.39"
					y1="927.48"
					x2="505.4"
					y2="927.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.4"
					y1="927.48"
					x2="505.4"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.99"
					y1="927.48"
					x2="603"
					y2="927.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603"
					y1="927.48"
					x2="603"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603"
					y1="928.73"
					x2="597.99"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.99"
					y1="928.73"
					x2="597.99"
					y2="927.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="506.65 948.75 506.65 928.73 504.77 928.73 504.77 948.75 506.65 948.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="598.62 948.75 598.62 928.73 596.74 928.73 596.74 948.75 598.62 948.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="533.04 865.03 529.94 868.12 593.64 931.83 596.74 928.73 533.04 865.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="504.77"
					y1="928.73"
					x2="504.15"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.77"
					y1="948.75"
					x2="504.15"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.15"
					y1="928.73"
					x2="504.15"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.62"
					y1="928.73"
					x2="599.24"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.62"
					y1="948.75"
					x2="599.24"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.24"
					y1="928.73"
					x2="599.24"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.65"
					y1="948.75"
					x2="506.65"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.65"
					y1="928.73"
					x2="504.77"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.77"
					y1="928.73"
					x2="504.77"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.77"
					y1="948.75"
					x2="506.65"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.62"
					y1="948.75"
					x2="598.62"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.62"
					y1="928.73"
					x2="596.74"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.74"
					y1="928.73"
					x2="596.74"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.74"
					y1="948.75"
					x2="598.62"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.04"
					y1="865.03"
					x2="529.94"
					y2="868.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.94"
					y1="868.12"
					x2="593.64"
					y2="931.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.64"
					y1="931.83"
					x2="596.74"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.74"
					y1="928.73"
					x2="533.04"
					y2="865.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.15"
					y1="928.73"
					x2="504.15"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="504.15"
					y1="928.73"
					x2="504.15"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="504.15"
					y1="928.73"
					x2="500.39"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="504.15"
					y1="928.73"
					x2="500.39"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="504.15"
					y1="948.75"
					x2="500.39"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="504.15"
					y1="948.75"
					x2="500.39"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="599.24"
					y1="928.73"
					x2="599.24"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="599.24"
					y1="928.73"
					x2="599.24"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="599.24"
					y1="928.73"
					x2="603"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="599.24"
					y1="928.73"
					x2="603"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="599.24"
					y1="948.75"
					x2="603"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="599.24"
					y1="948.75"
					x2="603"
					y2="948.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="605.79"
					y1="922.74"
					x2="605.79"
					y2="926.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="618.3"
					y1="922.74"
					x2="618.3"
					y2="926.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="618.3"
					y1="922.74"
					x2="605.79"
					y2="922.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="605.79"
					y1="827.64"
					x2="605.79"
					y2="823.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="618.3"
					y1="827.64"
					x2="618.3"
					y2="823.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="618.3"
					y1="827.64"
					x2="605.79"
					y2="827.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="618.3"
					y1="928.73"
					x2="618.3"
					y2="922.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="605.79"
					y1="922.74"
					x2="605.79"
					y2="928.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="604.54 828.89 605.79 828.89 605.79 823.89 604.54 823.89 604.54 828.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="605.79 921.49 604.54 921.49 604.54 926.49 605.79 926.49 605.79 921.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="618.3 828.89 619.55 828.89 619.55 823.89 618.3 823.89 618.3 828.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="619.55 921.49 618.3 921.49 618.3 926.49 619.55 926.49 619.55 921.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="604.54"
					y1="828.89"
					x2="604.54"
					y2="823.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.54"
					y1="823.89"
					x2="605.79"
					y2="823.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.79"
					y1="823.89"
					x2="605.79"
					y2="828.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.79"
					y1="828.89"
					x2="604.54"
					y2="828.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.79"
					y1="921.49"
					x2="605.79"
					y2="926.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.79"
					y1="926.49"
					x2="604.54"
					y2="926.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.54"
					y1="926.49"
					x2="604.54"
					y2="921.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.54"
					y1="921.49"
					x2="605.79"
					y2="921.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="828.89"
					x2="618.3"
					y2="823.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="823.89"
					x2="619.55"
					y2="823.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.55"
					y1="823.89"
					x2="619.55"
					y2="828.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.55"
					y1="828.89"
					x2="618.3"
					y2="828.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.55"
					y1="921.49"
					x2="619.55"
					y2="926.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.55"
					y1="926.49"
					x2="618.3"
					y2="926.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="926.49"
					x2="618.3"
					y2="921.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="921.49"
					x2="619.55"
					y2="921.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="605.79 830.15 618.3 830.15 618.3 828.27 605.79 828.27 605.79 830.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="605.79 922.11 618.3 922.11 618.3 920.23 605.79 920.23 605.79 922.11"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="682.01 856.53 678.91 853.44 615.2 917.14 618.3 920.23 682.01 856.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="618.3"
					y1="828.27"
					x2="618.3"
					y2="827.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.79"
					y1="828.27"
					x2="605.79"
					y2="827.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="827.64"
					x2="605.79"
					y2="827.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="922.11"
					x2="618.3"
					y2="922.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.79"
					y1="922.11"
					x2="605.79"
					y2="922.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="922.74"
					x2="605.79"
					y2="922.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.79"
					y1="830.15"
					x2="618.3"
					y2="830.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="830.15"
					x2="618.3"
					y2="828.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="828.27"
					x2="605.79"
					y2="828.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.79"
					y1="828.27"
					x2="605.79"
					y2="830.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.79"
					y1="922.11"
					x2="618.3"
					y2="922.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="922.11"
					x2="618.3"
					y2="920.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="920.23"
					x2="605.79"
					y2="920.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.79"
					y1="920.23"
					x2="605.79"
					y2="922.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.01"
					y1="856.53"
					x2="678.91"
					y2="853.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.91"
					y1="853.44"
					x2="615.2"
					y2="917.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="615.2"
					y1="917.14"
					x2="618.3"
					y2="920.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="920.23"
					x2="682.01"
					y2="856.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="827.64"
					x2="605.79"
					y2="827.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="618.3"
					y1="827.64"
					x2="605.79"
					y2="827.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="618.3"
					y1="827.64"
					x2="618.3"
					y2="823.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="618.3"
					y1="827.64"
					x2="618.3"
					y2="823.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="605.79"
					y1="827.64"
					x2="605.79"
					y2="823.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="605.79"
					y1="827.64"
					x2="605.79"
					y2="823.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="618.3"
					y1="922.74"
					x2="605.79"
					y2="922.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="618.3"
					y1="922.74"
					x2="605.79"
					y2="922.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="618.3"
					y1="922.74"
					x2="618.3"
					y2="926.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="618.3"
					y1="922.74"
					x2="618.3"
					y2="926.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="605.79"
					y1="922.74"
					x2="605.79"
					y2="926.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="605.79"
					y1="922.74"
					x2="605.79"
					y2="926.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="761.72"
					y1="683.21"
					x2="678.02"
					y2="683.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="767.29"
					y1="695.73"
					x2="767.29"
					y2="770.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="767.29"
					y1="770.92"
					x2="779.81"
					y2="770.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="779.81"
					y1="770.92"
					x2="788.11"
					y2="770.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="597.76"
					y1="555.65"
					x2="601.52"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="597.76"
					y1="568.16"
					x2="601.52"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="597.76"
					y1="568.16"
					x2="597.76"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="527.7"
					y1="555.65"
					x2="523.94"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="527.7"
					y1="568.16"
					x2="523.94"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="527.7"
					y1="568.16"
					x2="527.7"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="635.63"
					y1="555.65"
					x2="597.76"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="527.7"
					y1="555.65"
					x2="514.71"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="597.76"
					y1="568.16"
					x2="665.51"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="528.95 554.4 523.94 554.4 523.94 555.65 528.95 555.65 528.95 554.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="596.51 555.65 601.52 555.65 601.52 554.4 596.51 554.4 596.51 555.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="528.95 568.16 523.94 568.16 523.94 569.42 528.95 569.42 528.95 568.16"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="596.51 569.42 601.52 569.42 601.52 568.16 596.51 568.16 596.51 569.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="528.95"
					y1="554.4"
					x2="523.94"
					y2="554.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.94"
					y1="554.4"
					x2="523.94"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.94"
					y1="555.65"
					x2="528.95"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.95"
					y1="555.65"
					x2="528.95"
					y2="554.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.51"
					y1="555.65"
					x2="601.52"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.52"
					y1="555.65"
					x2="601.52"
					y2="554.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.52"
					y1="554.4"
					x2="596.51"
					y2="554.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.51"
					y1="554.4"
					x2="596.51"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.95"
					y1="568.16"
					x2="523.94"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.94"
					y1="568.16"
					x2="523.94"
					y2="569.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.94"
					y1="569.42"
					x2="528.95"
					y2="569.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.95"
					y1="569.42"
					x2="528.95"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.51"
					y1="569.42"
					x2="601.52"
					y2="569.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.52"
					y1="569.42"
					x2="601.52"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.52"
					y1="568.16"
					x2="596.51"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.51"
					y1="568.16"
					x2="596.51"
					y2="569.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="530.2 555.65 528.32 555.65 528.32 568.16 530.2 568.16 530.2 555.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="597.14 555.65 595.26 555.65 595.26 568.16 597.14 568.16 597.14 555.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="549.26 614.17 595.26 568.16 592.17 565.07 546.16 611.07 549.26 614.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="528.32"
					y1="568.16"
					x2="527.7"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.32"
					y1="555.65"
					x2="527.7"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.7"
					y1="568.16"
					x2="527.7"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.14"
					y1="568.16"
					x2="597.76"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.14"
					y1="555.65"
					x2="597.76"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.76"
					y1="568.16"
					x2="597.76"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.2"
					y1="555.65"
					x2="530.2"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.2"
					y1="568.16"
					x2="528.32"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.32"
					y1="568.16"
					x2="528.32"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.32"
					y1="555.65"
					x2="530.2"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.14"
					y1="555.65"
					x2="597.14"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.14"
					y1="568.16"
					x2="595.26"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.26"
					y1="568.16"
					x2="595.26"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.26"
					y1="555.65"
					x2="597.14"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.26"
					y1="614.17"
					x2="546.16"
					y2="611.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.16"
					y1="611.07"
					x2="592.17"
					y2="565.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.17"
					y1="565.07"
					x2="595.26"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.26"
					y1="568.16"
					x2="549.26"
					y2="614.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.7"
					y1="568.16"
					x2="527.7"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="527.7"
					y1="568.16"
					x2="527.7"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="527.7"
					y1="568.16"
					x2="523.94"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="527.7"
					y1="568.16"
					x2="523.94"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="527.7"
					y1="555.65"
					x2="523.94"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="527.7"
					y1="555.65"
					x2="523.94"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="597.76"
					y1="568.16"
					x2="597.76"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="597.76"
					y1="568.16"
					x2="597.76"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="597.76"
					y1="568.16"
					x2="601.52"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="597.76"
					y1="568.16"
					x2="601.52"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="597.76"
					y1="555.65"
					x2="601.52"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="597.76"
					y1="555.65"
					x2="601.52"
					y2="555.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="502.2"
					y1="471.89"
					x2="502.2"
					y2="475.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="514.71"
					y1="471.89"
					x2="514.71"
					y2="475.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="514.71"
					y1="471.89"
					x2="502.2"
					y2="471.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="502.2"
					y1="376.79"
					x2="502.2"
					y2="373.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="514.71"
					y1="376.79"
					x2="514.71"
					y2="373.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="514.71"
					y1="376.79"
					x2="502.2"
					y2="376.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="514.71"
					y1="476.79"
					x2="514.71"
					y2="471.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="500.95 378.05 502.2 378.05 502.2 373.04 500.95 373.04 500.95 378.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="502.2 470.64 500.95 470.64 500.95 475.64 502.2 475.64 502.2 470.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="514.71 378.05 515.97 378.05 515.97 373.04 514.71 373.04 514.71 378.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="515.97 470.64 514.71 470.64 514.71 475.64 515.97 475.64 515.97 470.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="500.95"
					y1="378.05"
					x2="500.95"
					y2="373.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.95"
					y1="373.04"
					x2="502.2"
					y2="373.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.2"
					y1="373.04"
					x2="502.2"
					y2="378.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.2"
					y1="378.05"
					x2="500.95"
					y2="378.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.2"
					y1="470.64"
					x2="502.2"
					y2="475.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.2"
					y1="475.64"
					x2="500.95"
					y2="475.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.95"
					y1="475.64"
					x2="500.95"
					y2="470.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.95"
					y1="470.64"
					x2="502.2"
					y2="470.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="378.05"
					x2="514.71"
					y2="373.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="373.04"
					x2="515.97"
					y2="373.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.97"
					y1="373.04"
					x2="515.97"
					y2="378.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.97"
					y1="378.05"
					x2="514.71"
					y2="378.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.97"
					y1="470.64"
					x2="515.97"
					y2="475.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.97"
					y1="475.64"
					x2="514.71"
					y2="475.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="475.64"
					x2="514.71"
					y2="470.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="470.64"
					x2="515.97"
					y2="470.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="502.2 379.29 514.71 379.29 514.71 377.42 502.2 377.42 502.2 379.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="502.2 471.26 514.71 471.26 514.71 469.39 502.2 469.39 502.2 471.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="578.42 405.68 575.32 402.59 511.62 466.29 514.71 469.39 578.42 405.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="514.71"
					y1="377.42"
					x2="514.71"
					y2="376.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.2"
					y1="377.42"
					x2="502.2"
					y2="376.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="376.79"
					x2="502.2"
					y2="376.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="471.26"
					x2="514.71"
					y2="471.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.2"
					y1="471.26"
					x2="502.2"
					y2="471.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="471.89"
					x2="502.2"
					y2="471.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.2"
					y1="379.29"
					x2="514.71"
					y2="379.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="379.29"
					x2="514.71"
					y2="377.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="377.42"
					x2="502.2"
					y2="377.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.2"
					y1="377.42"
					x2="502.2"
					y2="379.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.2"
					y1="471.26"
					x2="514.71"
					y2="471.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="471.26"
					x2="514.71"
					y2="469.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="469.39"
					x2="502.2"
					y2="469.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.2"
					y1="469.39"
					x2="502.2"
					y2="471.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.42"
					y1="405.68"
					x2="575.32"
					y2="402.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.32"
					y1="402.59"
					x2="511.62"
					y2="466.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.62"
					y1="466.29"
					x2="514.71"
					y2="469.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="469.39"
					x2="578.42"
					y2="405.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.71"
					y1="376.79"
					x2="502.2"
					y2="376.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="514.71"
					y1="376.79"
					x2="502.2"
					y2="376.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="514.71"
					y1="376.79"
					x2="514.71"
					y2="373.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="514.71"
					y1="376.79"
					x2="514.71"
					y2="373.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="502.2"
					y1="376.79"
					x2="502.2"
					y2="373.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="502.2"
					y1="376.79"
					x2="502.2"
					y2="373.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="514.71"
					y1="471.89"
					x2="502.2"
					y2="471.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="514.71"
					y1="471.89"
					x2="502.2"
					y2="471.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="514.71"
					y1="471.89"
					x2="514.71"
					y2="475.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="514.71"
					y1="471.89"
					x2="514.71"
					y2="475.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="502.2"
					y1="471.89"
					x2="502.2"
					y2="475.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="502.2"
					y1="471.89"
					x2="502.2"
					y2="475.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="678.02"
					y1="591.13"
					x2="678.02"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="665.51"
					y1="591.13"
					x2="665.51"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="665.51"
					y1="591.13"
					x2="678.02"
					y2="591.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="678.02"
					y1="661.2"
					x2="678.02"
					y2="664.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="665.51"
					y1="661.2"
					x2="665.51"
					y2="664.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="665.51"
					y1="661.2"
					x2="678.02"
					y2="661.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="678.02"
					y1="683.21"
					x2="678.02"
					y2="661.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="678.02"
					y1="591.13"
					x2="678.02"
					y2="568.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="665.51"
					y1="568.16"
					x2="665.51"
					y2="591.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="665.51"
					y1="661.2"
					x2="665.51"
					y2="683.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="679.27 659.95 678.02 659.95 678.02 664.96 679.27 664.96 679.27 659.95"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="678.02 592.38 679.27 592.38 679.27 587.38 678.02 587.38 678.02 592.38"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="665.51 659.95 664.25 659.95 664.25 664.96 665.51 664.96 665.51 659.95"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="664.25 592.38 665.51 592.38 665.51 587.38 664.25 587.38 664.25 592.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="679.27"
					y1="659.95"
					x2="679.27"
					y2="664.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.27"
					y1="664.96"
					x2="678.02"
					y2="664.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.02"
					y1="664.96"
					x2="678.02"
					y2="659.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.02"
					y1="659.95"
					x2="679.27"
					y2="659.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.02"
					y1="592.38"
					x2="678.02"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.02"
					y1="587.38"
					x2="679.27"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.27"
					y1="587.38"
					x2="679.27"
					y2="592.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.27"
					y1="592.38"
					x2="678.02"
					y2="592.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.51"
					y1="659.95"
					x2="665.51"
					y2="664.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.51"
					y1="664.96"
					x2="664.25"
					y2="664.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.25"
					y1="664.96"
					x2="664.25"
					y2="659.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.25"
					y1="659.95"
					x2="665.51"
					y2="659.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.25"
					y1="592.38"
					x2="664.25"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.25"
					y1="587.38"
					x2="665.51"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.51"
					y1="587.38"
					x2="665.51"
					y2="592.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.51"
					y1="592.38"
					x2="664.25"
					y2="592.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="678.02 658.7 665.51 658.7 665.51 660.58 678.02 660.58 678.02 658.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="678.02 591.76 665.51 591.76 665.51 593.64 678.02 593.64 678.02 591.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="619.5 639.64 622.6 642.74 668.6 596.73 665.51 593.64 619.5 639.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="665.51"
					y1="660.58"
					x2="665.51"
					y2="661.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.02"
					y1="660.58"
					x2="678.02"
					y2="661.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.51"
					y1="661.2"
					x2="678.02"
					y2="661.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.51"
					y1="591.76"
					x2="665.51"
					y2="591.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.02"
					y1="591.76"
					x2="678.02"
					y2="591.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.51"
					y1="591.13"
					x2="678.02"
					y2="591.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.02"
					y1="658.7"
					x2="665.51"
					y2="658.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.51"
					y1="658.7"
					x2="665.51"
					y2="660.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.51"
					y1="660.58"
					x2="678.02"
					y2="660.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.02"
					y1="660.58"
					x2="678.02"
					y2="658.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.02"
					y1="591.76"
					x2="665.51"
					y2="591.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.51"
					y1="591.76"
					x2="665.51"
					y2="593.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.51"
					y1="593.64"
					x2="678.02"
					y2="593.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.02"
					y1="593.64"
					x2="678.02"
					y2="591.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.5"
					y1="639.64"
					x2="622.6"
					y2="642.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.6"
					y1="642.74"
					x2="668.6"
					y2="596.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.6"
					y1="596.73"
					x2="665.51"
					y2="593.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.51"
					y1="593.64"
					x2="619.5"
					y2="639.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.51"
					y1="661.2"
					x2="678.02"
					y2="661.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="665.51"
					y1="661.2"
					x2="678.02"
					y2="661.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="665.51"
					y1="661.2"
					x2="665.51"
					y2="664.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="665.51"
					y1="661.2"
					x2="665.51"
					y2="664.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="678.02"
					y1="661.2"
					x2="678.02"
					y2="664.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="678.02"
					y1="661.2"
					x2="678.02"
					y2="664.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="665.51"
					y1="591.13"
					x2="678.02"
					y2="591.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="665.51"
					y1="591.13"
					x2="678.02"
					y2="591.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="665.51"
					y1="591.13"
					x2="665.51"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="665.51"
					y1="591.13"
					x2="665.51"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="678.02"
					y1="591.13"
					x2="678.02"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="678.02"
					y1="591.13"
					x2="678.02"
					y2="587.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="654.16"
					y1="394.35"
					x2="650.41"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="654.16"
					y1="406.87"
					x2="650.41"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="654.16"
					y1="406.87"
					x2="654.16"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="749.25"
					y1="394.35"
					x2="753"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="749.25"
					y1="406.87"
					x2="753"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="749.25"
					y1="406.87"
					x2="749.25"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="648.14"
					y1="406.87"
					x2="654.16"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="635.63"
					y1="394.35"
					x2="648.14"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="654.16"
					y1="394.35"
					x2="648.14"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="748 393.1 748 394.35 753 394.35 753 393.1 748 393.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="655.41 394.35 655.41 393.1 650.41 393.1 650.41 394.35 655.41 394.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="748 406.87 748 408.12 753 408.12 753 406.87 748 406.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="655.41 408.12 655.41 406.87 650.41 406.87 650.41 408.12 655.41 408.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="748"
					y1="393.1"
					x2="753"
					y2="393.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753"
					y1="393.1"
					x2="753"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753"
					y1="394.35"
					x2="748"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748"
					y1="394.35"
					x2="748"
					y2="393.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.41"
					y1="394.35"
					x2="650.41"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.41"
					y1="394.35"
					x2="650.41"
					y2="393.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.41"
					y1="393.1"
					x2="655.41"
					y2="393.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.41"
					y1="393.1"
					x2="655.41"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748"
					y1="406.87"
					x2="753"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753"
					y1="406.87"
					x2="753"
					y2="408.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753"
					y1="408.12"
					x2="748"
					y2="408.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748"
					y1="408.12"
					x2="748"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.41"
					y1="408.12"
					x2="650.41"
					y2="408.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.41"
					y1="408.12"
					x2="650.41"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.41"
					y1="406.87"
					x2="655.41"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.41"
					y1="406.87"
					x2="655.41"
					y2="408.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="746.75 394.35 746.75 406.87 748.63 406.87 748.63 394.35 746.75 394.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="654.78 394.35 654.78 406.87 656.66 406.87 656.66 394.35 654.78 394.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="720.36 470.57 723.46 467.47 659.76 403.77 656.66 406.87 720.36 470.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="748.63"
					y1="406.87"
					x2="749.25"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.63"
					y1="394.35"
					x2="749.25"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.25"
					y1="406.87"
					x2="749.25"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.78"
					y1="406.87"
					x2="654.16"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.78"
					y1="394.35"
					x2="654.16"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.16"
					y1="406.87"
					x2="654.16"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.75"
					y1="394.35"
					x2="746.75"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.75"
					y1="406.87"
					x2="748.63"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.63"
					y1="406.87"
					x2="748.63"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.63"
					y1="394.35"
					x2="746.75"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.78"
					y1="394.35"
					x2="654.78"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.78"
					y1="406.87"
					x2="656.66"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.66"
					y1="406.87"
					x2="656.66"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.66"
					y1="394.35"
					x2="654.78"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.36"
					y1="470.57"
					x2="723.46"
					y2="467.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.46"
					y1="467.47"
					x2="659.76"
					y2="403.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.76"
					y1="403.77"
					x2="656.66"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.66"
					y1="406.87"
					x2="720.36"
					y2="470.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.25"
					y1="406.87"
					x2="749.25"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="749.25"
					y1="406.87"
					x2="749.25"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="749.25"
					y1="406.87"
					x2="753"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="749.25"
					y1="406.87"
					x2="753"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="749.25"
					y1="394.35"
					x2="753"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="749.25"
					y1="394.35"
					x2="753"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="654.16"
					y1="406.87"
					x2="654.16"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="654.16"
					y1="406.87"
					x2="654.16"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="654.16"
					y1="406.87"
					x2="650.41"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="654.16"
					y1="406.87"
					x2="650.41"
					y2="406.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="654.16"
					y1="394.35"
					x2="650.41"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="654.16"
					y1="394.35"
					x2="650.41"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="378.43"
					y1="900.73"
					x2="203.01"
					y2="900.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="378.43"
					y1="900.73"
					x2="378.43"
					y2="913.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="294.07"
					y1="50"
					x2="294.07"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="490.29"
					y1="50"
					x2="490.29"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="602.39"
					y1="70.02"
					x2="602.39"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="462.33"
					y1="922.62"
					x2="462.33"
					y2="831.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.43"
					y1="831.68"
					x2="378.43"
					y2="922.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.33"
					y1="831.68"
					x2="378.43"
					y2="831.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.33"
					y1="837.94"
					x2="378.43"
					y2="837.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="280.79 728.86 343.13 728.86 344.11 728.6 344.83 727.88 345.1 726.89 345.1 685.16 344.83 684.18 344.11 683.46 343.13 683.19 280.79 683.19 279.81 683.46 279.08 684.18 278.82 685.16 278.82 726.89 279.08 727.88 279.81 728.6 280.79 728.86"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m280.79,728.86c-1.09,0-1.97-.88-1.97-1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.82"
					y1="685.16"
					x2="278.82"
					y2="726.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m278.82,685.16c0-1.09.88-1.97,1.97-1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.13"
					y1="683.19"
					x2="280.79"
					y2="683.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m343.13,683.19c1.09,0,1.97.88,1.97,1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.1"
					y1="726.89"
					x2="345.1"
					y2="685.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m345.1,726.89c0,1.09-.88,1.97-1.97,1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.79"
					y1="728.86"
					x2="343.13"
					y2="728.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.72"
					y1="723.94"
					x2="338.2"
					y2="723.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.17"
					y1="721.97"
					x2="340.17"
					y2="695.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.2"
					y1="693.05"
					x2="285.72"
					y2="693.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.75"
					y1="695.02"
					x2="283.75"
					y2="721.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.72"
					y1="723.94"
					x2="285.72"
					y2="723.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m340.17,721.97c0,1.09-.88,1.97-1.97,1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m338.2,693.05c1.09,0,1.97.88,1.97,1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m283.75,695.02c0-1.09.88-1.97,1.97-1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m285.72,723.94c-1.09,0-1.97-.88-1.97-1.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m314.91,702.9c0-1.63-1.32-2.96-2.96-2.96s-2.96,1.33-2.96,2.96,1.32,2.96,2.96,2.96,2.96-1.32,2.96-2.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="311.07 705.65 311.33 706.27 311.96 706.53 312.59 706.27 312.84 705.64 312.84 686.15 312.58 685.52 311.96 685.26 311.33 685.52 311.07 686.15 311.07 705.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="311.07"
					y1="686.15"
					x2="311.07"
					y2="705.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m311.07,686.15c0-.49.4-.89.89-.89s.89.4.89.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.84"
					y1="705.64"
					x2="312.84"
					y2="686.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m312.84,705.64h0c0,.49-.4.89-.89.89s-.89-.39-.89-.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="309.99 691.17 311.07 691.17 311.07 686.15 311.33 685.52 311.96 685.26 312.58 685.52 312.84 686.15 312.84 691.17 313.92 691.17 313.92 684.77 309.99 684.77 309.99 691.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="309.99"
					y1="684.77"
					x2="309.99"
					y2="691.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.92"
					y1="684.77"
					x2="309.99"
					y2="684.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.92"
					y1="691.17"
					x2="313.92"
					y2="684.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.84"
					y1="691.17"
					x2="313.92"
					y2="691.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.84"
					y1="686.15"
					x2="312.84"
					y2="691.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m311.07,686.15c0-.49.4-.89.89-.89s.89.4.89.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.07"
					y1="691.17"
					x2="311.07"
					y2="686.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.99"
					y1="691.17"
					x2="311.07"
					y2="691.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="310.02 694.72 311.07 694.72 311.07 691.27 310.02 691.27 310.02 694.72"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="310.02"
					y1="691.27"
					x2="310.02"
					y2="694.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.07"
					y1="691.27"
					x2="310.02"
					y2="691.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.07"
					y1="694.72"
					x2="311.07"
					y2="691.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.02"
					y1="694.72"
					x2="311.07"
					y2="694.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="313.9 694.72 313.9 691.27 312.84 691.27 312.84 694.72 313.9 694.72"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="312.84"
					y1="694.72"
					x2="313.9"
					y2="694.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.84"
					y1="691.27"
					x2="312.84"
					y2="694.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.9"
					y1="691.27"
					x2="312.84"
					y2="691.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.9"
					y1="694.72"
					x2="313.9"
					y2="691.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="738.08 775.12 738.08 840.19 788.11 840.19 788.11 775.12 738.08 775.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="738.08"
					y1="775.12"
					x2="738.08"
					y2="840.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.11"
					y1="775.12"
					x2="788.11"
					y2="840.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.08"
					y1="840.19"
					x2="788.11"
					y2="840.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.08"
					y1="775.12"
					x2="788.11"
					y2="775.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.14"
					y1="775.12"
					x2="786.14"
					y2="840.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.95"
					y1="782.63"
					x2="749.95"
					y2="832.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.95"
					y1="832.68"
					x2="779.98"
					y2="832.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.98"
					y1="832.68"
					x2="779.98"
					y2="782.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.98"
					y1="782.63"
					x2="749.95"
					y2="782.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.98"
					y1="780.66"
					x2="747.98"
					y2="834.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.98"
					y1="834.65"
					x2="781.95"
					y2="834.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.95"
					y1="834.65"
					x2="781.95"
					y2="780.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.95"
					y1="780.66"
					x2="747.98"
					y2="780.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m776.16,807.66c0-1.63-1.32-2.96-2.96-2.96s-2.96,1.32-2.96,2.96,1.32,2.96,2.96,2.96,2.96-1.32,2.96-2.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="785.4 805.19 781.27 805.59 780.33 805.91 775.12 806.56 774.43 806.93 774.15 807.66 774.43 808.38 775.12 808.75 780.33 809.4 781.27 809.73 785.4 810.12 786.85 809.65 787.75 808.42 787.75 806.9 786.85 805.67 785.4 805.19"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m785.4,805.19c1.36,0,2.46,1.1,2.46,2.47s-1.1,2.46-2.46,2.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.27"
					y1="809.73"
					x2="785.4"
					y2="810.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m781.27,809.73c-.33-.03-.65-.14-.94-.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.12"
					y1="808.75"
					x2="780.33"
					y2="809.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m775.12,808.75c-.55-.07-.97-.54-.97-1.09s.41-1.03.97-1.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.33"
					y1="805.91"
					x2="775.12"
					y2="806.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m780.33,805.91c.28-.18.6-.29.94-.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.4"
					y1="805.19"
					x2="781.27"
					y2="805.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.95"
					y1="809"
					x2="781.48"
					y2="809"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.48"
					y1="806.32"
					x2="782.95"
					y2="806.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.95"
					y1="806.32"
					x2="782.95"
					y2="809"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m781.48,809c-.74,0-1.34-.6-1.34-1.34s.6-1.34,1.34-1.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m780.33,809.4c-.59-.38-.95-1.04-.95-1.75s.36-1.37.95-1.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="722.39 874.08 720.39 878.55 719.7 883.39 720.39 888.23 722.39 892.69 724.91 895.64 728.09 897.87 735.54 900.7 741.72 901.7 747.98 901.33 753.99 899.6 762.21 900.28 769.7 903.71 771.82 905.06 776.17 906.64 780.79 906.4 782.61 905.69 787.47 905.69 787.47 903.66 785.26 903.66 787.31 900.27 788.11 896.39 788.11 870.39 786.75 865.36 783.17 861.59 778.23 859.97 777.63 859.97 774.51 860.49 769.59 863.13 762.18 866.53 754.06 867.2 748.02 865.45 741.74 865.07 735.54 866.07 728.09 868.91 724.91 871.14 722.39 874.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="765"
					y1="892.65"
					x2="765"
					y2="874.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.11"
					y1="870.39"
					x2="788.11"
					y2="883.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.17"
					y1="870.39"
					x2="787.17"
					y2="883.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.11"
					y1="896.39"
					x2="788.11"
					y2="883.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.17"
					y1="896.39"
					x2="787.17"
					y2="883.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765"
					y1="874.6"
					x2="768.46"
					y2="874.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.46"
					y1="874.6"
					x2="768.46"
					y2="877.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.46"
					y1="877.47"
					x2="765"
					y2="877.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765"
					y1="892.17"
					x2="768.46"
					y2="892.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.46"
					y1="892.17"
					x2="768.46"
					y2="889.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.46"
					y1="889.31"
					x2="765"
					y2="889.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.87"
					y1="903.66"
					x2="787.47"
					y2="903.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.87"
					y1="905.69"
					x2="787.47"
					y2="905.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.47"
					y1="905.69"
					x2="787.47"
					y2="903.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.87"
					y1="905.69"
					x2="778.87"
					y2="903.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.7"
					y1="883.39"
					x2="720.06"
					y2="880.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.06"
					y1="880.28"
					x2="720.86"
					y2="877.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.86"
					y1="877.28"
					x2="722.39"
					y2="874.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.39"
					y1="874.08"
					x2="724.91"
					y2="871.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.91"
					y1="871.14"
					x2="728.09"
					y2="868.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.09"
					y1="868.91"
					x2="731.7"
					y2="867.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.7"
					y1="867.26"
					x2="735.54"
					y2="866.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.54"
					y1="866.07"
					x2="741.73"
					y2="864.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.73"
					y1="864.99"
					x2="744.86"
					y2="864.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.86"
					y1="864.93"
					x2="747.97"
					y2="865.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.97"
					y1="865.28"
					x2="752.8"
					y2="866.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.8"
					y1="866.69"
					x2="757.48"
					y2="868.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.48"
					y1="868.88"
					x2="761.66"
					y2="871.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.66"
					y1="871.48"
					x2="765"
					y2="874.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.06"
					y1="867.2"
					x2="758.4"
					y2="867.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.4"
					y1="867.18"
					x2="762.62"
					y2="866.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.62"
					y1="866.46"
					x2="764.89"
					y2="865.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.89"
					y1="865.73"
					x2="767.14"
					y2="864.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.14"
					y1="864.67"
					x2="770.42"
					y2="862.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.42"
					y1="862.58"
					x2="773.81"
					y2="860.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.81"
					y1="860.73"
					x2="777.12"
					y2="860"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.12"
					y1="860"
					x2="780.42"
					y2="860.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.42"
					y1="860.28"
					x2="783.43"
					y2="861.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.43"
					y1="861.56"
					x2="784.73"
					y2="862.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.73"
					y1="862.58"
					x2="785.84"
					y2="863.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.84"
					y1="863.83"
					x2="787.07"
					y2="866.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.07"
					y1="866.05"
					x2="787.75"
					y2="868.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.75"
					y1="868.17"
					x2="788.11"
					y2="870.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.17"
					y1="870.39"
					x2="787.07"
					y2="869.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.07"
					y1="869.4"
					x2="786.44"
					y2="867.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.44"
					y1="867.35"
					x2="784.92"
					y2="865.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.92"
					y1="865.55"
					x2="782.8"
					y2="864.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.8"
					y1="864.41"
					x2="780.01"
					y2="863.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.01"
					y1="863.88"
					x2="777.13"
					y2="863.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.13"
					y1="863.75"
					x2="775.7"
					y2="863.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.7"
					y1="863.77"
					x2="774.57"
					y2="864.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.57"
					y1="864.37"
					x2="774.24"
					y2="865.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.24"
					y1="865.08"
					x2="772"
					y2="872.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772"
					y1="872.94"
					x2="771.34"
					y2="876.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.34"
					y1="876.85"
					x2="771.05"
					y2="880.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.05"
					y1="880.81"
					x2="771.05"
					y2="883.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.99"
					y1="899.6"
					x2="758.35"
					y2="899.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.35"
					y1="899.63"
					x2="762.58"
					y2="900.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.58"
					y1="900.34"
					x2="764.87"
					y2="901.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.87"
					y1="901.06"
					x2="767.14"
					y2="902.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.14"
					y1="902.11"
					x2="770.42"
					y2="904.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.42"
					y1="904.19"
					x2="773.81"
					y2="906.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.81"
					y1="906.04"
					x2="776.02"
					y2="906.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.02"
					y1="906.65"
					x2="778.3"
					y2="906.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.3"
					y1="906.79"
					x2="780.53"
					y2="906.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.53"
					y1="906.47"
					x2="782.61"
					y2="905.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.17"
					y1="896.39"
					x2="787.07"
					y2="897.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.07"
					y1="897.38"
					x2="786.44"
					y2="899.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.44"
					y1="899.42"
					x2="784.92"
					y2="901.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.92"
					y1="901.23"
					x2="782.8"
					y2="902.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.8"
					y1="902.36"
					x2="780.01"
					y2="902.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.01"
					y1="902.9"
					x2="777.13"
					y2="903.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.13"
					y1="903.02"
					x2="775.7"
					y2="903"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.7"
					y1="903"
					x2="774.57"
					y2="902.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.57"
					y1="902.4"
					x2="774.24"
					y2="901.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.24"
					y1="901.7"
					x2="772"
					y2="893.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772"
					y1="893.83"
					x2="771.34"
					y2="889.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.34"
					y1="889.93"
					x2="771.05"
					y2="885.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.05"
					y1="885.97"
					x2="771.05"
					y2="883.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.7"
					y1="883.39"
					x2="720.06"
					y2="886.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.06"
					y1="886.49"
					x2="720.86"
					y2="889.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.86"
					y1="889.5"
					x2="722.39"
					y2="892.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.39"
					y1="892.69"
					x2="724.91"
					y2="895.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.91"
					y1="895.64"
					x2="728.09"
					y2="897.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.09"
					y1="897.87"
					x2="731.7"
					y2="899.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.7"
					y1="899.51"
					x2="735.54"
					y2="900.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.54"
					y1="900.7"
					x2="741.73"
					y2="901.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.73"
					y1="901.78"
					x2="744.86"
					y2="901.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.86"
					y1="901.84"
					x2="747.97"
					y2="901.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.97"
					y1="901.49"
					x2="752.8"
					y2="900.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.8"
					y1="900.08"
					x2="757.48"
					y2="897.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.48"
					y1="897.89"
					x2="761.66"
					y2="895.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.66"
					y1="895.29"
					x2="765"
					y2="892.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.01"
					y1="861.6"
					x2="771.3"
					y2="862.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.3"
					y1="862.1"
					x2="770.25"
					y2="863.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.25"
					y1="863.53"
					x2="770"
					y2="864.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770"
					y1="864.77"
					x2="769.32"
					y2="872.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.32"
					y1="872.76"
					x2="769.01"
					y2="880.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.01"
					y1="880.77"
					x2="769.01"
					y2="883.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.01"
					y1="905.17"
					x2="771.3"
					y2="904.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.3"
					y1="904.67"
					x2="770.25"
					y2="903.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.25"
					y1="903.24"
					x2="770"
					y2="902"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770"
					y1="902"
					x2="769.32"
					y2="894.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.32"
					y1="894.01"
					x2="769.01"
					y2="886.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.01"
					y1="886.01"
					x2="769.01"
					y2="883.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.26"
					y1="903.66"
					x2="785.84"
					y2="902.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.84"
					y1="902.94"
					x2="787.07"
					y2="900.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.07"
					y1="900.72"
					x2="787.75"
					y2="898.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.75"
					y1="898.6"
					x2="788.11"
					y2="896.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="788.11 853.36 787.11 853.36 787.11 858.36 788.11 858.36 788.11 853.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="788.11"
					y1="858.36"
					x2="788.11"
					y2="853.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.11"
					y1="858.36"
					x2="788.11"
					y2="858.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.11"
					y1="853.36"
					x2="787.11"
					y2="858.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.11"
					y1="853.36"
					x2="787.11"
					y2="853.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="788.11 913.42 788.11 908.41 787.11 908.41 787.11 913.42 788.11 913.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="787.11"
					y1="913.42"
					x2="788.11"
					y2="913.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.11"
					y1="908.41"
					x2="787.11"
					y2="913.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.11"
					y1="908.41"
					x2="787.11"
					y2="908.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.11"
					y1="913.42"
					x2="788.11"
					y2="908.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="787.11 855.36 778.96 855.36 778.96 856.36 787.11 856.36 787.11 855.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="787.11"
					y1="856.36"
					x2="787.11"
					y2="855.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.96"
					y1="856.36"
					x2="787.11"
					y2="856.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.96"
					y1="855.36"
					x2="778.96"
					y2="856.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.11"
					y1="855.36"
					x2="778.96"
					y2="855.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="787.11 911.41 787.11 910.41 778.96 910.41 778.96 911.41 787.11 911.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="778.96"
					y1="911.41"
					x2="787.11"
					y2="911.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.96"
					y1="910.41"
					x2="778.96"
					y2="911.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.11"
					y1="910.41"
					x2="778.96"
					y2="910.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.11"
					y1="911.41"
					x2="787.11"
					y2="910.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="781.46 856.36 779.46 856.36 779.46 910.41 781.46 910.41 781.46 856.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="781.46"
					y1="910.41"
					x2="781.46"
					y2="856.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.46"
					y1="910.41"
					x2="781.46"
					y2="910.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.46"
					y1="856.36"
					x2="779.46"
					y2="910.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.46"
					y1="856.36"
					x2="779.46"
					y2="856.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.3"
					y1="770.92"
					x2="767.29"
					y2="770.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.29"
					y1="770.92"
					x2="767.29"
					y2="695.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="757.96 762.01 757.96 705.62 628.28 705.62 628.28 762.01 757.96 762.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="628.28"
					y1="762.01"
					x2="757.96"
					y2="762.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.28"
					y1="705.62"
					x2="628.28"
					y2="762.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.96"
					y1="705.62"
					x2="628.28"
					y2="705.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.96"
					y1="762.01"
					x2="757.96"
					y2="705.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="745.22 733.32 745.26 733.83 745.39 734.32 745.6 734.78 745.88 735.19 746.23 735.55 746.64 735.84 747.09 736.06 747.57 736.19 748.06 736.23 748.56 736.19 749.04 736.06 749.49 735.84 749.89 735.55 750.24 735.19 750.53 734.78 750.74 734.32 750.87 733.83 750.91 733.32 750.87 732.82 750.74 732.32 750.53 731.86 750.24 731.45 749.89 731.09 749.49 730.8 749.04 730.58 748.56 730.45 748.06 730.4 747.57 730.45 747.09 730.58 746.64 730.8 746.23 731.09 745.88 731.45 745.6 731.86 745.39 732.32 745.26 732.82 745.22 733.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="745.26"
					y1="732.81"
					x2="745.22"
					y2="733.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.39"
					y1="732.32"
					x2="745.26"
					y2="732.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.6"
					y1="731.86"
					x2="745.39"
					y2="732.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.88"
					y1="731.45"
					x2="745.6"
					y2="731.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.23"
					y1="731.09"
					x2="745.88"
					y2="731.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.64"
					y1="730.8"
					x2="746.23"
					y2="731.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.09"
					y1="730.58"
					x2="746.64"
					y2="730.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.57"
					y1="730.45"
					x2="747.09"
					y2="730.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.06"
					y1="730.4"
					x2="747.57"
					y2="730.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.56"
					y1="730.45"
					x2="748.06"
					y2="730.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.04"
					y1="730.58"
					x2="748.56"
					y2="730.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.49"
					y1="730.8"
					x2="749.04"
					y2="730.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.89"
					y1="731.09"
					x2="749.49"
					y2="730.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.24"
					y1="731.45"
					x2="749.89"
					y2="731.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.53"
					y1="731.86"
					x2="750.24"
					y2="731.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.74"
					y1="732.32"
					x2="750.53"
					y2="731.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.87"
					y1="732.81"
					x2="750.74"
					y2="732.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.91"
					y1="733.32"
					x2="750.87"
					y2="732.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.87"
					y1="733.83"
					x2="750.91"
					y2="733.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.74"
					y1="734.32"
					x2="750.87"
					y2="733.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.53"
					y1="734.78"
					x2="750.74"
					y2="734.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.24"
					y1="735.19"
					x2="750.53"
					y2="734.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.89"
					y1="735.55"
					x2="750.24"
					y2="735.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.49"
					y1="735.84"
					x2="749.89"
					y2="735.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.04"
					y1="736.06"
					x2="749.49"
					y2="735.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.56"
					y1="736.19"
					x2="749.04"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.06"
					y1="736.23"
					x2="748.56"
					y2="736.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.57"
					y1="736.19"
					x2="748.06"
					y2="736.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.09"
					y1="736.06"
					x2="747.57"
					y2="736.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.64"
					y1="735.84"
					x2="747.09"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.23"
					y1="735.55"
					x2="746.64"
					y2="735.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.88"
					y1="735.19"
					x2="746.23"
					y2="735.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.6"
					y1="734.78"
					x2="745.88"
					y2="735.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.39"
					y1="734.32"
					x2="745.6"
					y2="734.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.26"
					y1="733.83"
					x2="745.39"
					y2="734.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.22"
					y1="733.32"
					x2="745.26"
					y2="733.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="761.29 730.8 761.72 730.84 762.13 730.96 762.52 731.14 762.87 731.39 763.17 731.7 763.42 732.06 763.6 732.46 763.71 732.88 763.75 733.32 763.71 733.76 763.6 734.18 763.42 734.58 763.17 734.94 762.87 735.25 762.52 735.5 762.13 735.68 761.72 735.8 761.29 735.83 757.17 735.43 756.84 735.37 756.53 735.26 756.24 735.1 751.04 734.44 750.86 734.4 750.69 734.33 750.53 734.23 750.39 734.1 750.27 733.95 750.18 733.79 750.12 733.61 750.08 733.42 750.08 733.23 750.12 733.04 750.18 732.86 750.27 732.69 750.39 732.54 750.53 732.41 750.69 732.31 750.86 732.24 751.04 732.2 756.24 731.54 756.53 731.38 756.84 731.27 757.17 731.21 761.29 730.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="761.29"
					y1="730.8"
					x2="757.17"
					y2="731.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.24"
					y1="731.54"
					x2="751.04"
					y2="732.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.04"
					y1="734.44"
					x2="756.24"
					y2="735.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.17"
					y1="735.43"
					x2="761.29"
					y2="735.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.85"
					y1="734.69"
					x2="757.39"
					y2="734.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.39"
					y1="731.95"
					x2="758.85"
					y2="731.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.85"
					y1="731.95"
					x2="758.85"
					y2="734.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m756.24,731.54c.28-.19.6-.3.94-.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m751.04,734.44c-.55-.07-.96-.55-.96-1.12s.41-1.05.96-1.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m757.17,735.43c-.33-.03-.65-.15-.94-.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m761.29,730.8c1.36,0,2.46,1.13,2.46,2.52s-1.1,2.52-2.46,2.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m757.39,734.69c-.74,0-1.34-.61-1.34-1.37s.6-1.37,1.34-1.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m756.24,735.1c-.59-.39-.95-1.06-.95-1.79s.36-1.39.95-1.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="271.28 733.1 271.28 676 215.16 676 215.16 733.1 271.28 733.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="215.16"
					y1="733.1"
					x2="217.4"
					y2="733.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221"
					y1="733.1"
					x2="227.01"
					y2="733.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.61"
					y1="733.1"
					x2="236.62"
					y2="733.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.22"
					y1="733.1"
					x2="246.23"
					y2="733.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.83"
					y1="733.1"
					x2="255.84"
					y2="733.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.44"
					y1="733.1"
					x2="265.45"
					y2="733.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.05"
					y1="733.1"
					x2="271.28"
					y2="733.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.16"
					y1="676"
					x2="215.16"
					y2="678.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.16"
					y1="682.33"
					x2="215.16"
					y2="688.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.16"
					y1="691.94"
					x2="215.16"
					y2="697.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.16"
					y1="701.55"
					x2="215.16"
					y2="707.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.16"
					y1="711.16"
					x2="215.16"
					y2="717.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.16"
					y1="720.77"
					x2="215.16"
					y2="726.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.16"
					y1="730.38"
					x2="215.16"
					y2="733.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.28"
					y1="676"
					x2="269.05"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.45"
					y1="676"
					x2="259.44"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.84"
					y1="676"
					x2="249.83"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.23"
					y1="676"
					x2="240.22"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.62"
					y1="676"
					x2="230.61"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.01"
					y1="676"
					x2="221"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.4"
					y1="676"
					x2="215.16"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.28"
					y1="733.1"
					x2="271.28"
					y2="730.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.28"
					y1="726.77"
					x2="271.28"
					y2="720.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.28"
					y1="717.16"
					x2="271.28"
					y2="711.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.28"
					y1="707.55"
					x2="271.28"
					y2="701.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.28"
					y1="697.95"
					x2="271.28"
					y2="691.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.28"
					y1="688.34"
					x2="271.28"
					y2="682.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.28"
					y1="678.73"
					x2="271.28"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="215.38 736.06 215.38 737.78 271.07 737.78 271.07 736.06 262.33 736.06 262.33 737.47 224.11 737.47 224.11 736.06 215.38 736.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="224.11"
					y1="736.06"
					x2="215.38"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="224.11"
					y1="737.47"
					x2="224.11"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="262.33"
					y1="737.47"
					x2="224.11"
					y2="737.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="262.33"
					y1="736.06"
					x2="262.33"
					y2="737.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="271.07"
					y1="736.06"
					x2="262.33"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="271.07"
					y1="737.78"
					x2="271.07"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="215.38"
					y1="737.78"
					x2="271.07"
					y2="737.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="215.38"
					y1="736.06"
					x2="215.38"
					y2="737.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="213.19 736.06 273.25 736.06 273.25 733.1 213.19 733.1 213.19 736.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="213.19"
					y1="733.1"
					x2="213.19"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="273.25"
					y1="733.1"
					x2="213.19"
					y2="733.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="273.25"
					y1="736.06"
					x2="273.25"
					y2="733.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="213.19"
					y1="736.06"
					x2="273.25"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="271.07"
					y1="736.06"
					x2="271.07"
					y2="737.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.07"
					y1="737.78"
					x2="215.38"
					y2="737.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.38"
					y1="737.78"
					x2="215.38"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.25"
					y1="736.06"
					x2="213.19"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.11"
					y1="736.06"
					x2="224.11"
					y2="737.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.11"
					y1="737.47"
					x2="262.33"
					y2="737.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.33"
					y1="737.47"
					x2="262.33"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.25"
					y1="733.1"
					x2="273.25"
					y2="736.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.19"
					y1="736.06"
					x2="213.19"
					y2="733.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.19"
					y1="733.1"
					x2="273.25"
					y2="733.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.59"
					y1="647.19"
					x2="692.56"
					y2="647.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.56"
					y1="647.19"
					x2="692.56"
					y2="603.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.59"
					y1="656.35"
					x2="708.59"
					y2="594.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.81"
					y1="594.52"
					x2="749.81"
					y2="656.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.81"
					y1="656.35"
					x2="687.98"
					y2="656.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.98"
					y1="594.52"
					x2="749.81"
					y2="594.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.12"
					y1="656.35"
					x2="689.12"
					y2="594.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.59"
					y1="603.68"
					x2="692.56"
					y2="603.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.98"
					y1="656.35"
					x2="687.98"
					y2="594.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="381.22"
					y1="831.68"
					x2="381.22"
					y2="826.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="381.22"
					y1="826.16"
					x2="384.02"
					y2="826.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.02"
					y1="826.16"
					x2="384.02"
					y2="831.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.33"
					y1="840.67"
					x2="460.47"
					y2="840.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.02"
					y1="840.67"
					x2="451.01"
					y2="840.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.41"
					y1="840.67"
					x2="441.4"
					y2="840.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.8"
					y1="840.67"
					x2="431.79"
					y2="840.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.19"
					y1="840.67"
					x2="422.18"
					y2="840.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.58"
					y1="840.67"
					x2="412.57"
					y2="840.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.97"
					y1="840.67"
					x2="402.96"
					y2="840.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.36"
					y1="840.67"
					x2="393.35"
					y2="840.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.75"
					y1="840.67"
					x2="383.74"
					y2="840.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.29"
					y1="840.67"
					x2="378.43"
					y2="840.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.43"
					y1="840.67"
					x2="203.01"
					y2="840.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.19"
					y1="676"
					x2="217.31"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.91"
					y1="676"
					x2="226.92"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.52"
					y1="676"
					x2="236.53"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.13"
					y1="676"
					x2="246.14"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.74"
					y1="676"
					x2="255.75"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.35"
					y1="676"
					x2="265.36"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.96"
					y1="676"
					x2="274.97"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.57"
					y1="676"
					x2="284.57"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.18"
					y1="676"
					x2="294.19"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.79"
					y1="676"
					x2="303.79"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.4"
					y1="676"
					x2="313.4"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.01"
					y1="676"
					x2="323.01"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.62"
					y1="676"
					x2="332.62"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.23"
					y1="676"
					x2="342.23"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.84"
					y1="676"
					x2="351.84"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.45"
					y1="676"
					x2="361.45"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.06"
					y1="676"
					x2="371.06"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.67"
					y1="676"
					x2="380.67"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.28"
					y1="676"
					x2="390.28"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.89"
					y1="676"
					x2="399.89"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.49"
					y1="676"
					x2="409.5"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.1"
					y1="676"
					x2="419.11"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.71"
					y1="676"
					x2="428.72"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432.32"
					y1="676"
					x2="438.33"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.93"
					y1="676"
					x2="446.05"
					y2="676"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.07"
					y1="50"
					x2="490.29"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.29"
					y1="70.02"
					x2="294.07"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.39"
					y1="50"
					x2="768.94"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.94"
					y1="70.02"
					x2="602.39"
					y2="70.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.94"
					y1="647.19"
					x2="742.94"
					y2="603.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.94"
					y1="603.68"
					x2="713.17"
					y2="603.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.17"
					y1="603.68"
					x2="713.17"
					y2="647.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.17"
					y1="647.19"
					x2="742.94"
					y2="647.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="353.95 835.66 278.88 835.66 278.88 900.73 353.95 900.73 353.95 835.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="353.95"
					y1="835.66"
					x2="278.88"
					y2="835.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.95"
					y1="900.73"
					x2="278.88"
					y2="900.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.95"
					y1="898.76"
					x2="278.88"
					y2="898.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.95"
					y1="835.66"
					x2="353.95"
					y2="900.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.88"
					y1="835.66"
					x2="278.88"
					y2="900.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.03"
					y1="838.62"
					x2="283.81"
					y2="838.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.81"
					y1="838.62"
					x2="281.84"
					y2="840.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.84"
					y1="840.59"
					x2="281.84"
					y2="895.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.84"
					y1="895.8"
					x2="283.81"
					y2="897.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.81"
					y1="897.77"
					x2="349.03"
					y2="897.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.03"
					y1="897.77"
					x2="351"
					y2="895.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351"
					y1="895.8"
					x2="351"
					y2="840.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351"
					y1="840.59"
					x2="349.03"
					y2="838.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m345.04,851.93c0-5.44-4.41-9.85-9.85-9.85s-9.85,4.41-9.85,9.85,4.41,9.85,9.85,9.85,9.85-4.41,9.85-9.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m342.57,884.46c0-4.08-3.31-7.39-7.39-7.39s-7.39,3.31-7.39,7.39,3.31,7.39,7.39,7.39,7.39-3.31,7.39-7.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m305.04,851.93c0-4.08-3.31-7.39-7.39-7.39s-7.39,3.31-7.39,7.39,3.31,7.39,7.39,7.39,7.39-3.31,7.39-7.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m307.5,884.46c0-5.44-4.41-9.85-9.85-9.85s-9.85,4.41-9.85,9.85,4.41,9.85,9.85,9.85,9.85-4.41,9.85-9.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.43"
					y1="870.7"
					x2="374.2"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.6"
					y1="870.7"
					x2="364.59"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.99"
					y1="870.7"
					x2="354.98"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.38"
					y1="870.7"
					x2="345.37"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.77"
					y1="870.7"
					x2="335.76"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.16"
					y1="870.7"
					x2="326.15"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.55"
					y1="870.7"
					x2="316.55"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.94"
					y1="870.7"
					x2="306.94"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.33"
					y1="870.7"
					x2="297.33"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="293.72"
					y1="870.7"
					x2="287.72"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.11"
					y1="870.7"
					x2="278.11"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.5"
					y1="870.7"
					x2="268.5"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.89"
					y1="870.7"
					x2="258.89"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.28"
					y1="870.7"
					x2="249.28"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.67"
					y1="870.7"
					x2="239.67"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.07"
					y1="870.7"
					x2="230.06"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.46"
					y1="870.7"
					x2="220.45"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.85"
					y1="870.7"
					x2="210.84"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.24"
					y1="870.7"
					x2="203.01"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="502.21 70.02 490.29 70.02 490.29 50 602.39 50 602.39 70.02 569.3 70.02 569.3 152.4 514.72 152.4 514.72 376.79 502.21 376.79 502.21 70.02"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.31"
				/>
				<polygon
					points="817.01 50 817.01 948.76 599.24 948.76 599.24 928.73 605.79 928.73 605.79 922.74 618.3 922.74 618.3 928.73 788.1 928.73 788.1 770.92 767.3 770.92 767.3 695.73 618.3 695.73 618.3 827.65 605.79 827.65 605.79 683.21 665.5 683.21 665.5 661.2 678.02 661.2 678.02 683.21 761.72 683.21 761.72 568.17 678.02 568.17 678.02 591.13 665.5 591.13 665.5 568.17 597.77 568.17 597.77 555.65 635.63 555.65 635.63 489.3 514.72 489.3 514.72 555.65 527.69 555.65 527.69 568.17 502.21 568.17 502.21 471.89 514.72 471.89 514.72 476.79 635.63 476.79 635.63 394.35 654.16 394.35 654.16 406.87 648.13 406.87 648.13 555.65 796.99 555.65 796.99 406.87 749.25 406.87 749.25 394.35 796.99 394.35 796.99 70.02 768.94 70.02 768.94 50 817.01 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.31"
				/>
				<polygon
					points="504.14 928.73 504.14 948.76 182.99 948.76 182.99 50 294.06 50 294.06 70.02 203.01 70.02 203.01 646.29 213.19 646.29 213.19 736.06 203.01 736.06 203.01 900.73 378.43 900.73 378.43 922.62 462.34 922.62 462.34 928.73 504.14 928.73"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.31"
				/>
			</g>
			<g id="text">
				<path d="m416.72,884.11h-1.63l-1.96-3.28c-.18-.3-.35-.56-.52-.77-.17-.22-.34-.39-.52-.53-.17-.14-.36-.23-.57-.29-.2-.07-.43-.1-.68-.1h-1.13v4.97h-1.37v-11.69h3.49c.51,0,.98.07,1.41.2.43.13.81.32,1.13.58.32.26.57.59.75.98.18.39.27.84.27,1.36,0,.41-.06.78-.19,1.13-.12.34-.29.64-.52.91-.22.27-.49.49-.82.68-.32.18-.67.33-1.07.43v.03c.2.09.36.19.51.3.15.11.29.24.42.39.13.15.26.33.38.52.13.19.27.41.43.67l2.19,3.51Zm-7.01-10.45v4.24h1.86c.34,0,.66-.05.95-.15.29-.1.55-.25.76-.44.21-.2.38-.43.5-.71.12-.28.18-.6.18-.95,0-.63-.2-1.11-.61-1.46-.4-.35-.99-.53-1.75-.53h-1.88Zm14.99,6.61h-5.9c.02.93.27,1.65.75,2.15.48.51,1.14.76,1.97.76.94,0,1.8-.31,2.59-.93v1.26c-.73.53-1.7.8-2.91.8s-2.11-.38-2.78-1.13c-.67-.76-1.01-1.83-1.01-3.2,0-1.3.37-2.36,1.1-3.17.74-.82,1.66-1.23,2.75-1.23s1.94.35,2.54,1.06c.6.71.9,1.69.9,2.94v.7Zm-1.37-1.13c0-.77-.19-1.37-.56-1.8-.36-.43-.87-.64-1.52-.64s-1.17.23-1.61.68c-.44.45-.71,1.04-.82,1.77h4.51Zm7.36-6.21c-.26-.15-.56-.22-.89-.22-.93,0-1.4.59-1.4,1.77v1.29h1.96v1.14h-1.96v7.21h-1.33v-7.21h-1.43v-1.14h1.43v-1.35c0-.88.25-1.57.76-2.07.51-.51,1.14-.77,1.89-.77.41,0,.73.05.97.15v1.21Z" />
				<path d="m432.1,884.29c-.25,0-.46-.09-.64-.27-.17-.18-.26-.39-.26-.64s.09-.46.26-.64c.18-.18.39-.28.64-.28s.47.09.65.28c.18.18.27.39.27.64s-.09.46-.27.64c-.18.18-.4.27-.65.27Z" />
				<path d="m230.96,711.26v-11.61h4c.9,0,1.59.06,2.07.17.67.15,1.23.43,1.7.83.61.52,1.07,1.18,1.37,1.99.31.8.46,1.72.46,2.76,0,.88-.1,1.66-.31,2.34-.21.68-.47,1.25-.79,1.69-.32.44-.68.79-1.06,1.05-.38.25-.84.45-1.39.58-.54.13-1.16.2-1.86.2h-4.19Zm1.54-1.37h2.48c.77,0,1.36-.07,1.8-.21.44-.14.79-.34,1.05-.6.36-.36.65-.85.85-1.46.21-.62.31-1.36.31-2.24,0-1.21-.2-2.15-.6-2.79-.4-.65-.88-1.09-1.45-1.31-.41-.16-1.07-.24-1.99-.24h-2.44v8.87Zm12.2,1.37l-3.08-11.61h1.58l1.77,7.61c.19.8.35,1.59.49,2.38.3-1.24.47-1.96.52-2.15l2.21-7.84h1.85l1.66,5.87c.42,1.46.72,2.83.9,4.11.15-.73.34-1.58.58-2.53l1.82-7.46h1.54l-3.18,11.61h-1.48l-2.45-8.84c-.21-.74-.33-1.19-.36-1.36-.12.53-.23.99-.34,1.36l-2.46,8.84h-1.57Z" />
				<path d="m654.83,816.35v-18.14h5.16c1.57,0,2.81.38,3.73,1.15s1.38,1.77,1.38,3c0,1.03-.28,1.92-.83,2.68-.56.76-1.32,1.3-2.3,1.62v.05c1.22.14,2.2.61,2.93,1.39.73.78,1.1,1.79,1.1,3.04,0,1.55-.56,2.81-1.67,3.77-1.11.96-2.52,1.44-4.21,1.44h-5.29Zm2.12-16.21v5.86h2.18c1.16,0,2.08-.28,2.74-.83.67-.56,1-1.36,1-2.38,0-1.76-1.16-2.64-3.48-2.64h-2.44Zm0,7.77v6.53h2.88c1.25,0,2.21-.3,2.9-.89.69-.59,1.04-1.4,1.04-2.43,0-2.14-1.46-3.21-4.38-3.21h-2.44Zm21.71,8.45h-2.07v-2.02h-.05c-.9,1.55-2.23,2.33-3.98,2.33-1.29,0-2.3-.34-3.04-1.02-.73-.68-1.09-1.59-1.09-2.72,0-2.42,1.42-3.83,4.27-4.22l3.88-.54c0-2.2-.89-3.3-2.67-3.3-1.56,0-2.97.53-4.22,1.59v-2.12c1.27-.81,2.74-1.21,4.4-1.21,3.04,0,4.57,1.61,4.57,4.83v8.42Zm-2.07-6.55l-3.12.43c-.96.13-1.69.38-2.18.72-.49.34-.73.94-.73,1.81,0,.63.22,1.15.67,1.56.46.4,1.06.59,1.81.59,1.03,0,1.88-.36,2.54-1.07.67-.73,1.01-1.64,1.01-2.74v-1.29Zm12,6.42c-.49.27-1.13.4-1.93.4-2.27,0-3.4-1.26-3.4-3.79v-7.66h-2.23v-1.77h2.23v-3.16l2.07-.67v3.83h3.26v1.77h-3.26v7.3c0,.87.15,1.49.44,1.86.3.37.78.56,1.47.56.52,0,.97-.14,1.35-.43v1.77Zm13.52.13h-2.07v-7.46c0-2.7-1-4.05-3.01-4.05-1.01,0-1.86.39-2.55,1.18-.69.78-1.04,1.77-1.04,3v7.34h-2.07v-19.17h2.07v8.37h.05c.99-1.64,2.41-2.45,4.25-2.45,2.92,0,4.38,1.76,4.38,5.27v7.98Z" />
				<path d="m516.95,816.77h-9.61v-18.14h9.21v1.92h-7.08v6.03h6.55v1.91h-6.55v6.35h7.49v1.92Zm13.99,0h-2.07v-7.39c0-2.75-1-4.12-3.01-4.12-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.39h-2.07v-12.95h2.07v2.15h.05c.98-1.64,2.39-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.13,2.23,1.13,3.96v7.92Zm9.94-.13c-.49.27-1.13.4-1.93.4-2.27,0-3.4-1.26-3.4-3.79v-7.66h-2.23v-1.77h2.23v-3.16l2.07-.67v3.83h3.26v1.77h-3.26v7.3c0,.87.15,1.49.44,1.86.3.37.78.56,1.47.56.52,0,.97-.14,1.35-.43v1.77Zm9.55-10.72c-.36-.28-.89-.42-1.57-.42-.89,0-1.63.42-2.23,1.25-.59.83-.89,1.97-.89,3.41v6.6h-2.07v-12.95h2.07v2.67h.05c.3-.91.75-1.62,1.35-2.12.61-.51,1.29-.77,2.04-.77.54,0,.95.06,1.24.18v2.15Zm12.59-2.1l-5.96,15.02c-1.06,2.68-2.55,4.02-4.48,4.02-.54,0-.99-.05-1.35-.16v-1.86c.45.15.86.23,1.23.23,1.05,0,1.83-.62,2.35-1.87l1.04-2.45-5.06-12.93h2.3l3.5,9.97c.04.13.13.46.27.99h.08c.04-.2.13-.52.25-.96l3.68-9.99h2.15Z" />
				<path d="m605.64,271.64v-18.14h5.16c1.57,0,2.81.38,3.73,1.15.92.77,1.38,1.77,1.38,3,0,1.03-.28,1.92-.83,2.68-.56.76-1.32,1.3-2.3,1.62v.05c1.22.14,2.2.61,2.93,1.39.73.78,1.1,1.79,1.1,3.04,0,1.55-.56,2.81-1.67,3.77-1.11.96-2.52,1.44-4.21,1.44h-5.29Zm2.12-16.21v5.86h2.18c1.16,0,2.08-.28,2.74-.83.67-.56,1-1.36,1-2.38,0-1.76-1.16-2.64-3.48-2.64h-2.44Zm0,7.77v6.53h2.88c1.25,0,2.21-.3,2.9-.89.69-.59,1.04-1.4,1.04-2.43,0-2.14-1.46-3.21-4.38-3.21h-2.44Zm22.83,2.49h-9.14c.03,1.44.42,2.55,1.16,3.34.74.78,1.76,1.18,3.06,1.18,1.46,0,2.8-.48,4.02-1.44v1.95c-1.14.83-2.64,1.24-4.51,1.24s-3.27-.59-4.31-1.76c-1.05-1.18-1.57-2.84-1.57-4.97,0-2.02.57-3.65,1.71-4.92,1.15-1.27,2.57-1.91,4.26-1.91s3.01.55,3.93,1.64c.93,1.1,1.39,2.62,1.39,4.57v1.09Zm-2.12-1.76c0-1.2-.3-2.13-.87-2.79-.56-.67-1.35-1-2.36-1s-1.81.35-2.49,1.05c-.68.7-1.1,1.61-1.26,2.74h6.99Zm16.3,7.71h-2.07v-2.2h-.05c-.96,1.67-2.45,2.5-4.45,2.5-1.63,0-2.93-.58-3.91-1.73-.97-1.16-1.45-2.74-1.45-4.74,0-2.14.54-3.86,1.62-5.15,1.08-1.29,2.52-1.93,4.31-1.93s3.07.7,3.88,2.1h.05v-8.02h2.07v19.17Zm-2.07-5.86v-1.91c0-1.05-.35-1.93-1.04-2.66-.69-.73-1.57-1.09-2.63-1.09-1.26,0-2.26.46-2.98,1.39-.73.93-1.09,2.21-1.09,3.84,0,1.49.35,2.67,1.04,3.54.7.86,1.64,1.29,2.81,1.29s2.09-.42,2.81-1.25c.73-.83,1.09-1.89,1.09-3.16Zm13.01-5c-.36-.28-.89-.42-1.57-.42-.89,0-1.63.42-2.23,1.25-.59.83-.89,1.97-.89,3.41v6.6h-2.07v-12.95h2.07v2.67h.05c.3-.91.75-1.62,1.35-2.12.61-.51,1.29-.77,2.04-.77.54,0,.95.06,1.24.18v2.15Zm7.65,11.15c-1.91,0-3.44-.6-4.59-1.81-1.14-1.21-1.71-2.82-1.71-4.82,0-2.18.59-3.87,1.78-5.1,1.19-1.22,2.79-1.83,4.82-1.83s3.44.59,4.51,1.78c1.09,1.19,1.63,2.84,1.63,4.94s-.59,3.72-1.76,4.97c-1.16,1.24-2.73,1.86-4.69,1.86Zm.15-11.81c-1.33,0-2.39.46-3.16,1.37-.78.9-1.16,2.15-1.16,3.74s.39,2.74,1.18,3.63c.78.89,1.83,1.33,3.15,1.33s2.37-.43,3.09-1.3c.73-.87,1.09-2.1,1.09-3.71s-.36-2.87-1.09-3.74c-.72-.88-1.75-1.32-3.09-1.32Zm15.01,11.81c-1.91,0-3.44-.6-4.59-1.81-1.14-1.21-1.71-2.82-1.71-4.82,0-2.18.59-3.87,1.78-5.1,1.19-1.22,2.79-1.83,4.82-1.83s3.44.59,4.51,1.78c1.09,1.19,1.63,2.84,1.63,4.94s-.59,3.72-1.76,4.97c-1.16,1.24-2.73,1.86-4.69,1.86Zm.15-11.81c-1.33,0-2.39.46-3.16,1.37-.78.9-1.16,2.15-1.16,3.74s.39,2.74,1.18,3.63c.78.89,1.83,1.33,3.15,1.33s2.37-.43,3.09-1.3c.72-.87,1.09-2.1,1.09-3.71s-.36-2.87-1.09-3.74c-.72-.88-1.75-1.32-3.09-1.32Zm27.98,11.51h-2.07v-7.44c0-1.43-.22-2.47-.67-3.11-.44-.64-1.18-.96-2.23-.96-.89,0-1.64.4-2.26,1.21-.62.81-.92,1.78-.92,2.91v7.39h-2.07v-7.69c0-2.55-.98-3.82-2.95-3.82-.91,0-1.66.38-2.25,1.15-.59.76-.89,1.75-.89,2.97v7.39h-2.07v-12.95h2.07v2.05h.05c.92-1.57,2.26-2.35,4.02-2.35.89,0,1.66.25,2.31.75.66.49,1.11,1.13,1.35,1.93.96-1.79,2.39-2.68,4.3-2.68,2.85,0,4.27,1.76,4.27,5.27v7.98Z" />
				<path d="m613.39,291.14c0,1.21-.12,2.28-.36,3.23-.24.94-.59,1.73-1.05,2.39-.46.65-1.02,1.15-1.68,1.49-.66.34-1.42.51-2.26.51s-1.64-.15-2.3-.46v-1.44c.73.41,1.51.62,2.34.62.59,0,1.12-.12,1.59-.37.47-.25.87-.6,1.2-1.07.32-.47.57-1.05.74-1.74.17-.69.26-1.47.26-2.36h-.04c-.56,1.13-1.54,1.7-2.94,1.7-.56,0-1.08-.1-1.55-.29-.47-.2-.88-.48-1.22-.85-.34-.37-.61-.8-.8-1.31s-.29-1.06-.29-1.66c0-.65.1-1.24.31-1.78.21-.54.51-1,.88-1.39.38-.39.83-.7,1.34-.91.52-.21,1.09-.32,1.7-.32.66,0,1.25.13,1.76.4.51.26.95.65,1.3,1.17.35.51.62,1.14.8,1.89.18.75.28,1.6.28,2.57Zm-1.63-1.35c0-.51-.07-.97-.2-1.39-.13-.42-.31-.77-.54-1.07-.23-.3-.51-.53-.84-.69-.32-.17-.67-.25-1.05-.25s-.7.07-1.01.22c-.31.14-.59.34-.82.61-.23.26-.41.57-.54.93-.13.36-.19.74-.19,1.17,0,.47.06.88.18,1.25.13.37.31.68.54.94.23.25.51.44.84.58.33.13.7.2,1.09.2.35,0,.68-.06.98-.19.31-.13.58-.31.81-.53.23-.23.41-.49.54-.79.13-.31.2-.63.2-.98h0Z" />
				<rect x="615.84" y="285.34" width="1.33" height="4.11" />
				<path d="m628.01,294.34c0,.64-.1,1.24-.31,1.77-.21.54-.5,1.01-.86,1.4-.37.39-.81.7-1.31.92-.51.21-1.06.32-1.66.32-.66,0-1.26-.14-1.78-.41-.52-.28-.97-.67-1.33-1.19-.36-.52-.64-1.16-.83-1.9s-.29-1.59-.29-2.53c0-1.15.13-2.19.38-3.12.26-.94.62-1.74,1.09-2.4.47-.67,1.04-1.18,1.7-1.54.66-.36,1.4-.54,2.22-.54.91,0,1.64.13,2.19.38v1.43c-.68-.35-1.4-.52-2.15-.52-.59,0-1.12.13-1.59.4-.47.26-.88.64-1.21,1.12-.34.48-.6,1.06-.78,1.74-.18.68-.27,1.44-.27,2.27h.04c.61-1.1,1.61-1.65,3.01-1.65.58,0,1.09.1,1.55.29.47.2.86.48,1.19.84.33.36.59.78.76,1.28.18.5.27,1.05.27,1.66Zm-1.54.19c0-.46-.06-.87-.17-1.24-.12-.37-.29-.68-.51-.94-.21-.26-.48-.45-.8-.59-.32-.14-.68-.21-1.09-.21-.37,0-.72.07-1.04.21-.32.14-.59.33-.83.58-.23.24-.42.52-.55.85-.13.32-.19.66-.19,1.02,0,.45.06.88.19,1.28.13.39.31.74.54,1.03.23.29.51.53.83.7.32.17.68.25,1.08.25s.73-.07,1.04-.21c.31-.15.58-.35.8-.61.22-.26.39-.56.51-.92.12-.36.18-.76.18-1.2Z" />
				<path d="m631.61,285.34v4.11h-1.33v-4.11h1.33Zm3.05,0v4.11h-1.33v-4.11h1.33Z" />
				<path d="m649.75,289.11l-3.16,4.76,3.11,4.65h-1.76l-1.85-3.05c-.12-.19-.25-.43-.41-.72h-.04c-.03.06-.17.29-.43.72l-1.89,3.05h-1.74l3.21-4.62-3.07-4.8h1.76l1.82,3.22c.13.24.27.48.4.74h.04l2.35-3.95h1.66Z" />
				<path d="m661.82,298.53h-1.51v-11.39c-.12.12-.29.25-.51.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.09-.52.36-.2.7-.4,1.02-.61.32-.21.59-.42.83-.63h.57v13.48Zm12.9-6.65c0,1.1-.1,2.08-.3,2.93-.2.85-.48,1.57-.86,2.16-.37.58-.84,1.03-1.39,1.33-.55.3-1.17.45-1.87.45-.66,0-1.25-.14-1.77-.43-.51-.29-.95-.72-1.31-1.28s-.63-1.24-.81-2.05c-.18-.82-.28-1.75-.28-2.8,0-1.15.09-2.17.29-3.05.2-.88.48-1.62.86-2.22.37-.6.84-1.05,1.39-1.35.56-.31,1.2-.46,1.91-.46,2.76,0,4.15,2.25,4.15,6.76Zm-1.54.15c0-3.75-.89-5.63-2.68-5.63-1.88,0-2.82,1.91-2.82,5.73,0,3.56.92,5.34,2.77,5.34s2.73-1.81,2.73-5.44Z" />
				<rect x="677.01" y="285.34" width="1.33" height="4.11" />
				<path d="m686.44,298.53h-1.51v-11.39c-.12.12-.29.25-.51.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.09-.52.36-.2.7-.4,1.02-.61.32-.21.59-.42.83-.63h.57v13.48Zm12.9-6.65c0,1.1-.1,2.08-.3,2.93-.2.85-.48,1.57-.86,2.16-.37.58-.84,1.03-1.39,1.33-.55.3-1.17.45-1.87.45-.66,0-1.25-.14-1.77-.43-.51-.29-.95-.72-1.31-1.28-.36-.56-.63-1.24-.81-2.05-.18-.82-.28-1.75-.28-2.8,0-1.15.09-2.17.28-3.05.2-.88.48-1.62.86-2.22.37-.6.84-1.05,1.39-1.35.56-.31,1.2-.46,1.91-.46,2.76,0,4.15,2.25,4.15,6.76Zm-1.54.15c0-3.75-.89-5.63-2.68-5.63-1.88,0-2.82,1.91-2.82,5.73,0,3.56.92,5.34,2.77,5.34s2.73-1.81,2.73-5.44Z" />
				<path d="m702.96,285.34v4.11h-1.33v-4.11h1.33Zm3.05,0v4.11h-1.33v-4.11h1.33Z" />
				<path d="m297.12,799.16h-2.96l-7.01-8.3c-.26-.31-.42-.52-.48-.63h-.05v8.93h-2.12v-18.14h2.12v8.52h.05c.12-.19.28-.39.48-.62l6.78-7.9h2.64l-7.78,8.7,8.32,9.43Zm3.17-16.24c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.13.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.24h-2.07v-12.95h2.07v12.95Zm10.19-.13c-.49.27-1.13.4-1.93.4-2.27,0-3.4-1.26-3.4-3.79v-7.66h-2.23v-1.77h2.23v-3.16l2.07-.67v3.83h3.26v1.77h-3.26v7.3c0,.87.15,1.49.44,1.86.3.37.78.56,1.47.56.52,0,.97-.14,1.35-.43v1.77Zm11.59-.47c-.99.6-2.18.9-3.54.9-1.85,0-3.34-.6-4.48-1.8-1.13-1.21-1.69-2.77-1.69-4.68,0-2.13.61-3.84,1.83-5.13,1.22-1.3,2.85-1.95,4.89-1.95,1.14,0,2.14.21,3.01.63v2.12c-.96-.67-1.99-1.01-3.09-1.01-1.32,0-2.41.48-3.26,1.43-.84.94-1.26,2.19-1.26,3.73s.4,2.71,1.19,3.59c.8.88,1.87,1.32,3.21,1.32,1.13,0,2.19-.38,3.19-1.13v1.97Zm13.87.59h-2.07v-7.46c0-2.7-1-4.05-3.01-4.05-1.01,0-1.86.39-2.55,1.18-.69.78-1.04,1.77-1.04,3v7.34h-2.07v-19.17h2.07v8.37h.05c.99-1.64,2.41-2.45,4.25-2.45,2.92,0,4.38,1.76,4.38,5.27v7.98Zm14.31-5.96h-9.14c.03,1.44.42,2.55,1.16,3.34s1.76,1.18,3.06,1.18c1.46,0,2.8-.48,4.02-1.44v1.95c-1.14.83-2.64,1.24-4.51,1.24s-3.27-.59-4.31-1.76c-1.05-1.18-1.57-2.84-1.57-4.97,0-2.02.57-3.65,1.71-4.92,1.15-1.27,2.57-1.91,4.26-1.91s3.01.55,3.93,1.64c.93,1.1,1.39,2.62,1.39,4.57v1.09Zm-2.12-1.76c0-1.2-.3-2.13-.87-2.79-.56-.67-1.35-1-2.36-1s-1.81.35-2.49,1.05c-.68.7-1.1,1.61-1.26,2.74h6.99Zm16,7.71h-2.07v-7.39c0-2.75-1-4.12-3.01-4.12-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.39h-2.07v-12.95h2.07v2.15h.05c.98-1.64,2.39-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.13,2.23,1.13,3.96v7.92Z" />
				<path d="m251,356.39h-9.41v-18.14h2.12v16.21h7.28v1.92Zm3.57-16.24c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.13.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.24h-2.07v-12.95h2.07v12.95Zm14.37-12.95l-5.16,12.95h-2.04l-4.91-12.95h2.28l3.29,9.41c.24.69.4,1.29.46,1.81h.05c.08-.65.22-1.24.4-1.76l3.44-9.46h2.19Zm3.28-3.29c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.13.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.24h-2.07v-12.95h2.07v12.95Zm14.94,0h-2.07v-7.39c0-2.75-1-4.12-3.01-4.12-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.39h-2.07v-12.95h2.07v2.15h.05c.98-1.64,2.39-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.13,2.23,1.13,3.96v7.92Zm14.96-1.04c0,4.76-2.28,7.13-6.83,7.13-1.6,0-3-.3-4.2-.91v-2.07c1.46.81,2.85,1.21,4.17,1.21,3.19,0,4.78-1.69,4.78-5.08v-1.42h-.05c-.99,1.65-2.47,2.48-4.45,2.48-1.61,0-2.91-.57-3.9-1.72-.98-1.16-1.47-2.7-1.47-4.64,0-2.2.53-3.95,1.58-5.25,1.06-1.3,2.51-1.95,4.35-1.95s3.04.7,3.88,2.1h.05v-1.8h2.07v11.91Zm-2.07-4.82v-1.91c0-1.03-.35-1.91-1.05-2.64-.69-.73-1.56-1.1-2.59-1.1-1.28,0-2.28.47-3.01,1.4-.73.93-1.09,2.23-1.09,3.91,0,1.44.35,2.6,1.04,3.47.7.86,1.62,1.29,2.77,1.29s2.11-.41,2.83-1.24c.73-.83,1.1-1.88,1.1-3.17Z" />
				<polygon points="316.51 338.25 307.81 359.4 305.88 359.4 314.55 338.25 316.51 338.25" />
				<path d="m318.63,356.39v-18.14h5.01c6.39,0,9.59,2.95,9.59,8.84,0,2.8-.89,5.05-2.67,6.75-1.77,1.69-4.14,2.54-7.12,2.54h-4.81Zm2.12-16.21v14.29h2.71c2.38,0,4.23-.64,5.55-1.91s1.99-3.08,1.99-5.41c0-4.65-2.47-6.97-7.41-6.97h-2.83Zm16.74-.03c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.13.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.24h-2.07v-12.95h2.07v12.95Zm14.87,0h-2.07v-7.39c0-2.75-1-4.12-3.01-4.12-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.39h-2.07v-12.95h2.07v2.15h.05c.98-1.64,2.39-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.13,2.23,1.13,3.96v7.92Zm4.9-16.24c-.37,0-.69-.13-.95-.38-.26-.25-.39-.57-.39-.96s.13-.71.39-.96c.26-.26.58-.39.95-.39s.7.13.96.39c.27.25.4.57.4.96s-.13.69-.4.95c-.26.26-.58.39-.96.39Zm1.01,16.24h-2.07v-12.95h2.07v12.95Zm14.87,0h-2.07v-7.39c0-2.75-1-4.12-3.01-4.12-1.04,0-1.9.39-2.58,1.18-.67.78-1.01,1.76-1.01,2.95v7.39h-2.07v-12.95h2.07v2.15h.05c.98-1.64,2.39-2.45,4.25-2.45,1.42,0,2.5.46,3.25,1.38.75.91,1.13,2.23,1.13,3.96v7.92Zm14.89-1.04c0,4.76-2.28,7.13-6.83,7.13-1.6,0-3-.3-4.2-.91v-2.07c1.46.81,2.85,1.21,4.17,1.21,3.19,0,4.78-1.69,4.78-5.08v-1.42h-.05c-.99,1.65-2.47,2.48-4.45,2.48-1.61,0-2.91-.57-3.9-1.72-.98-1.16-1.47-2.7-1.47-4.64,0-2.2.53-3.95,1.58-5.25,1.06-1.3,2.51-1.95,4.35-1.95s3.04.7,3.88,2.1h.05v-1.8h2.07v11.91Zm-2.07-4.82v-1.91c0-1.03-.35-1.91-1.05-2.64-.69-.73-1.56-1.1-2.59-1.1-1.28,0-2.28.47-3.01,1.4-.73.93-1.09,2.23-1.09,3.91,0,1.44.35,2.6,1.04,3.47.7.86,1.62,1.29,2.77,1.29s2.11-.41,2.83-1.24c.73-.83,1.1-1.88,1.1-3.17Z" />
				<path d="m413.84,356.39h-2.53l-3.04-5.08c-.28-.47-.55-.87-.81-1.2-.26-.34-.53-.61-.81-.82-.27-.21-.56-.36-.89-.46-.31-.1-.67-.15-1.06-.15h-1.75v7.71h-2.12v-18.14h5.41c.79,0,1.52.1,2.19.3.67.19,1.26.49,1.75.9.5.4.89.91,1.16,1.52.28.6.42,1.3.42,2.11,0,.63-.1,1.21-.29,1.75-.19.52-.46.99-.81,1.4-.35.41-.77.77-1.26,1.06-.49.29-1.04.51-1.66.67v.05c.3.13.56.29.78.47.23.17.44.37.64.61.2.24.4.51.59.81.2.3.43.64.67,1.04l3.4,5.45Zm-10.88-16.21v6.58h2.88c.53,0,1.02-.08,1.47-.24.46-.16.85-.39,1.18-.68.33-.3.59-.67.77-1.1.19-.44.28-.93.28-1.47,0-.97-.32-1.72-.95-2.26-.62-.55-1.53-.82-2.72-.82h-2.91Zm18.42,16.52c-1.91,0-3.44-.6-4.59-1.81-1.14-1.21-1.71-2.82-1.71-4.82,0-2.18.59-3.87,1.78-5.1s2.79-1.83,4.82-1.83,3.44.59,4.51,1.78c1.09,1.19,1.63,2.84,1.63,4.94s-.59,3.72-1.76,4.97c-1.16,1.24-2.73,1.86-4.69,1.86Zm.15-11.81c-1.33,0-2.39.46-3.16,1.37-.78.9-1.16,2.15-1.16,3.74s.39,2.74,1.18,3.63c.78.89,1.83,1.33,3.15,1.33s2.37-.43,3.09-1.3c.73-.87,1.09-2.1,1.09-3.71s-.36-2.87-1.09-3.74c-.72-.88-1.75-1.32-3.09-1.32Zm14.95,11.81c-1.91,0-3.44-.6-4.59-1.81-1.14-1.21-1.71-2.82-1.71-4.82,0-2.18.59-3.87,1.78-5.1,1.19-1.22,2.79-1.83,4.82-1.83s3.44.59,4.51,1.78c1.09,1.19,1.63,2.84,1.63,4.94s-.59,3.72-1.76,4.97c-1.16,1.24-2.73,1.86-4.69,1.86Zm.15-11.81c-1.33,0-2.39.46-3.16,1.37-.78.9-1.16,2.15-1.16,3.74s.39,2.74,1.18,3.63c.78.89,1.83,1.33,3.15,1.33s2.37-.43,3.09-1.3c.73-.87,1.09-2.1,1.09-3.71s-.36-2.87-1.09-3.74c-.72-.88-1.75-1.32-3.09-1.32Zm27.93,11.51h-2.07v-7.44c0-1.43-.22-2.47-.67-3.11-.44-.64-1.18-.96-2.23-.96-.89,0-1.64.4-2.26,1.21-.62.81-.92,1.78-.92,2.91v7.39h-2.07v-7.69c0-2.55-.98-3.82-2.95-3.82-.91,0-1.66.38-2.25,1.15-.59.76-.89,1.75-.89,2.97v7.39h-2.07v-12.95h2.07v2.05h.05c.92-1.57,2.26-2.35,4.02-2.35.89,0,1.66.25,2.31.75.66.49,1.11,1.13,1.35,1.93.96-1.79,2.39-2.68,4.3-2.68,2.85,0,4.27,1.76,4.27,5.27v7.98Z" />
				<path d="m310.15,375.9c0,1.21-.12,2.28-.36,3.23-.24.94-.59,1.73-1.05,2.39-.46.65-1.02,1.15-1.68,1.49-.66.34-1.42.51-2.26.51s-1.64-.15-2.3-.46v-1.44c.73.41,1.51.62,2.34.62.59,0,1.12-.12,1.59-.37.47-.25.87-.6,1.2-1.07.32-.47.57-1.05.74-1.74.17-.69.26-1.47.26-2.36h-.04c-.56,1.13-1.54,1.7-2.94,1.7-.56,0-1.08-.1-1.55-.29-.47-.2-.88-.48-1.22-.85-.34-.37-.61-.8-.8-1.31s-.29-1.06-.29-1.66c0-.65.1-1.24.31-1.78.21-.54.51-1,.88-1.39.38-.39.83-.7,1.34-.91.52-.21,1.09-.32,1.7-.32.66,0,1.25.13,1.76.4.51.26.95.65,1.3,1.17.35.51.62,1.14.8,1.89s.28,1.6.28,2.57Zm-1.63-1.35c0-.51-.07-.97-.2-1.39-.13-.42-.31-.77-.54-1.07-.23-.3-.51-.53-.84-.69-.32-.17-.67-.25-1.05-.25s-.7.07-1.01.22c-.31.14-.59.34-.82.61-.23.26-.41.57-.54.93-.13.36-.19.74-.19,1.17,0,.47.06.88.18,1.25.13.37.31.68.54.94.23.25.51.44.84.58.33.13.7.2,1.09.2.35,0,.68-.06.98-.19.31-.13.58-.31.81-.53.23-.23.41-.49.54-.79.13-.31.2-.63.2-.98h0Z" />
				<rect x="312.59" y="370.09" width="1.33" height="4.11" />
				<path d="m322.02,383.28h-1.51v-11.39c-.12.12-.29.25-.51.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.09-.52.36-.2.7-.4,1.02-.61.32-.21.59-.42.83-.63h.57v13.48Zm10.17,0h-1.51v-11.39c-.12.12-.29.25-.51.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.09-.52.36-.2.7-.4,1.02-.61.32-.21.59-.42.83-.63h.57v13.48Z" />
				<path d="m338.55,370.09v4.11h-1.33v-4.11h1.33Zm3.05,0v4.11h-1.33v-4.11h1.33Z" />
				<path d="m356.68,373.86l-3.16,4.76,3.11,4.65h-1.76l-1.85-3.05c-.12-.19-.25-.43-.41-.72h-.04c-.03.06-.17.29-.43.72l-1.89,3.05h-1.74l3.21-4.62-3.07-4.8h1.76l1.82,3.22c.13.24.27.48.4.74h.04l2.35-3.95h1.66Z" />
				<path d="m368.75,383.28h-1.51v-11.39c-.12.12-.29.25-.51.4-.22.15-.47.29-.75.44-.28.15-.57.29-.88.41-.31.13-.61.23-.9.3v-1.53c.33-.09.68-.21,1.05-.37.37-.16.74-.33,1.09-.52.36-.2.7-.4,1.02-.61.32-.21.59-.42.83-.63h.57v13.48Zm12.75-7.38c0,1.21-.12,2.28-.36,3.23-.24.94-.59,1.73-1.05,2.39-.46.65-1.02,1.15-1.68,1.49-.66.34-1.42.51-2.26.51s-1.64-.15-2.3-.46v-1.44c.73.41,1.51.62,2.34.62.59,0,1.12-.12,1.59-.37.47-.25.87-.6,1.2-1.07.32-.47.57-1.05.74-1.74.17-.69.26-1.47.26-2.36h-.04c-.56,1.13-1.54,1.7-2.94,1.7-.56,0-1.08-.1-1.55-.29-.47-.2-.88-.48-1.22-.85-.34-.37-.61-.8-.8-1.31s-.29-1.06-.29-1.66c0-.65.1-1.24.31-1.78.21-.54.51-1,.88-1.39.38-.39.83-.7,1.34-.91.52-.21,1.09-.32,1.7-.32.66,0,1.25.13,1.76.4.51.26.95.65,1.3,1.17.35.51.62,1.14.8,1.89s.28,1.6.28,2.57Zm-1.63-1.35c0-.51-.07-.97-.2-1.39-.13-.42-.31-.77-.54-1.07-.23-.3-.51-.53-.84-.69-.32-.17-.67-.25-1.05-.25s-.7.07-1.01.22c-.31.14-.59.34-.82.61-.23.26-.41.57-.54.93-.13.36-.19.74-.19,1.17,0,.47.06.88.18,1.25.13.37.31.68.54.94.23.25.51.44.84.58.33.13.7.2,1.09.2.35,0,.68-.06.98-.19.31-.13.58-.31.81-.53.23-.23.41-.49.54-.79.13-.31.2-.63.2-.98h0Z" />
				<rect x="383.94" y="370.09" width="1.33" height="4.11" />
				<path d="m393.81,373.55c0-.4-.06-.76-.19-1.06-.12-.3-.29-.55-.51-.74-.21-.2-.47-.35-.76-.45-.29-.1-.61-.15-.96-.15-.29,0-.58.04-.86.12-.28.08-.56.19-.83.33-.26.14-.52.31-.77.51-.25.2-.48.41-.69.65v-1.62c.42-.41.9-.72,1.42-.94.53-.22,1.17-.33,1.92-.33.54,0,1.04.08,1.5.24.46.15.86.38,1.2.68.34.3.6.67.79,1.11.2.44.29.95.29,1.52,0,.52-.06.99-.18,1.42-.12.42-.3.82-.54,1.2-.24.37-.54.73-.91,1.08-.37.34-.8.69-1.3,1.05-.62.44-1.13.82-1.54,1.13-.4.31-.72.61-.96.88-.23.27-.4.54-.5.82-.09.27-.14.58-.14.94h6.57v1.35h-8.14v-.65c0-.56.06-1.06.18-1.49.12-.43.32-.84.61-1.22.28-.39.65-.77,1.1-1.16.46-.39,1.02-.82,1.68-1.31.48-.34.88-.67,1.2-.98.32-.31.59-.63.78-.94s.33-.63.41-.95c.09-.32.13-.67.13-1.03Z" />
				<path d="m399.72,370.09v4.11h-1.33v-4.11h1.33Zm3.05,0v4.11h-1.33v-4.11h1.33Z" />
				<path d="m689.38,474.03l-3.72,13.19h-1.81l-2.71-9.64c-.12-.41-.19-.86-.21-1.34h-.04c-.04.45-.12.9-.24,1.32l-2.73,9.66h-1.79l-3.86-13.19h1.7l2.8,10.12c.12.42.19.86.22,1.32h.05c.03-.32.13-.77.29-1.32l2.92-10.12h1.48l2.8,10.19c.1.35.17.76.22,1.23h.04c.02-.32.11-.74.25-1.27l2.69-10.15h1.67Zm8.31,13.19h-1.51v-1.47h-.04c-.66,1.13-1.62,1.69-2.9,1.69-.94,0-1.67-.25-2.21-.74-.53-.5-.79-1.16-.79-1.98,0-1.76,1.04-2.78,3.11-3.07l2.82-.4c0-1.6-.65-2.4-1.94-2.4-1.13,0-2.16.39-3.07,1.16v-1.54c.93-.59,1.99-.88,3.2-.88,2.21,0,3.32,1.17,3.32,3.51v6.12Zm-1.51-4.76l-2.27.31c-.7.1-1.23.27-1.58.52-.36.25-.53.68-.53,1.32,0,.46.16.84.49,1.13.33.29.77.43,1.32.43.75,0,1.36-.26,1.85-.78.49-.53.74-1.19.74-2v-.94Zm5.67,4.76h-1.51v-13.94h1.51v13.94Zm10.67,0h-2.12l-4.16-4.52h-.04v4.52h-1.51v-13.94h1.51v8.84h.04l3.95-4.31h1.98l-4.37,4.54,4.71,4.87Z" />
				<rect x="713.66" y="481.38" width="5.02" height="1.19" />
				<path d="m723.15,487.22h-1.54v-13.19h1.54v13.19Zm11.09,0h-1.51v-5.37c0-2-.73-3-2.19-3-.75,0-1.38.29-1.88.86-.49.56-.74,1.28-.74,2.14v5.37h-1.51v-9.42h1.51v1.56h.04c.71-1.19,1.74-1.78,3.09-1.78,1.03,0,1.82.33,2.36,1,.55.66.82,1.62.82,2.88v5.76Z" />
				<path d="m688.75,511.79c-.97.51-2.19.77-3.64.77-1.88,0-3.38-.6-4.51-1.81-1.13-1.21-1.69-2.79-1.69-4.75,0-2.11.63-3.81,1.9-5.11,1.27-1.3,2.88-1.95,4.83-1.95,1.25,0,2.29.18,3.11.54v1.65c-.94-.53-1.99-.79-3.13-.79-1.51,0-2.74.51-3.69,1.52-.94,1.01-1.41,2.36-1.41,4.06s.44,2.89,1.32,3.84c.88.95,2.04,1.43,3.47,1.43,1.32,0,2.47-.29,3.44-.88v1.5Zm4,.55h-1.51v-13.94h1.51v13.94Zm6.99.22c-1.39,0-2.5-.44-3.34-1.32-.83-.88-1.24-2.05-1.24-3.5,0-1.58.43-2.82,1.3-3.71.86-.89,2.03-1.33,3.5-1.33s2.5.43,3.28,1.3c.79.86,1.19,2.06,1.19,3.6s-.43,2.71-1.28,3.61c-.85.9-1.98,1.35-3.41,1.35Zm.11-8.59c-.97,0-1.73.33-2.3.99-.56.66-.85,1.56-.85,2.72s.28,2,.86,2.64c.57.64,1.33.97,2.29.97s1.72-.32,2.24-.95c.53-.63.79-1.53.79-2.69s-.26-2.08-.79-2.72c-.52-.64-1.27-.96-2.24-.96Zm6.43,8.03v-1.62c.82.61,1.73.91,2.71.91,1.32,0,1.99-.44,1.99-1.32,0-.25-.06-.46-.17-.63-.11-.18-.26-.33-.46-.47-.19-.13-.42-.25-.68-.36-.26-.11-.54-.22-.84-.34-.42-.17-.78-.33-1.1-.5-.31-.17-.58-.36-.79-.57-.21-.21-.37-.46-.48-.73-.1-.27-.16-.59-.16-.95,0-.44.1-.83.3-1.17.2-.34.47-.63.81-.86.34-.23.72-.41,1.15-.52.44-.12.88-.17,1.34-.17.82,0,1.54.14,2.19.42v1.53c-.69-.45-1.49-.68-2.39-.68-.28,0-.54.03-.76.1-.23.06-.42.15-.59.27-.16.12-.29.26-.38.42-.09.16-.13.34-.13.53,0,.25.04.45.13.62.09.17.22.31.4.44.17.13.38.25.63.35.25.1.52.22.84.34.42.16.79.32,1.12.5.33.17.61.36.85.57.23.21.41.45.53.73.13.28.19.6.19.98,0,.47-.1.87-.31,1.21-.2.34-.48.63-.82.86-.34.23-.74.4-1.19.51-.45.11-.92.17-1.41.17-.97,0-1.81-.19-2.52-.56Zm16.13-3.99h-6.65c.02,1.05.31,1.86.85,2.43.54.57,1.28.86,2.23.86,1.06,0,2.04-.35,2.92-1.05v1.42c-.83.6-1.92.9-3.28.9s-2.38-.43-3.14-1.28c-.76-.86-1.14-2.06-1.14-3.61,0-1.47.41-2.66,1.24-3.58.83-.93,1.87-1.39,3.1-1.39s2.19.4,2.86,1.2c.67.8,1.01,1.9,1.01,3.32v.79Zm-1.54-1.28c0-.87-.22-1.55-.63-2.03-.41-.48-.98-.73-1.72-.73s-1.32.25-1.81.76c-.5.51-.8,1.17-.92,2h5.09Zm8.2,5.52c-.36.2-.82.29-1.41.29-1.65,0-2.47-.92-2.47-2.76v-5.57h-1.62v-1.29h1.62v-2.3l1.51-.49v2.79h2.37v1.29h-2.37v5.31c0,.63.11,1.08.32,1.35s.57.4,1.07.4c.38,0,.71-.1.98-.31v1.29Z" />
				<path d="m726.72,621.16l-2.98,10.56h-1.45l-2.17-7.72c-.09-.33-.15-.69-.17-1.08h-.03c-.03.36-.09.72-.19,1.06l-2.19,7.73h-1.44l-3.09-10.56h1.36l2.25,8.1c.09.34.15.69.18,1.06h.04c.02-.26.1-.61.23-1.06l2.33-8.1h1.19l2.24,8.16c.08.28.14.61.18.99h.03c.02-.26.09-.59.2-1.02l2.16-8.13h1.34Z" />
				<polygon points="732.88 621.16 727.82 633.48 726.69 633.48 731.74 621.16 732.88 621.16" />
				<path d="m734.11,631.72v-10.56h2.92c3.72,0,5.58,1.72,5.58,5.15,0,1.63-.52,2.94-1.55,3.93-1.03.99-2.41,1.48-4.15,1.48h-2.8Zm1.24-9.44v8.32h1.58c1.38,0,2.46-.37,3.23-1.11.77-.74,1.16-1.79,1.16-3.15,0-2.71-1.44-4.06-4.32-4.06h-1.65Z" />
			</g>
		</g>
	)
}

export default PlanG
